// Standard French Content
// Generated based on English equivalents from Twi curriculum

export const frenchData = {
    name: "French", // Pan-African French
    flagEmoji: "🌍",
    flagImageUrl: "https://firebasestorage.googleapis.com/v0/b/speak-roots-v2.firebasestorage.app/o/public%2Fmarketing%2Ffrancophone%20flags.webp?alt=media&token=a695095e-aeb4-4cfe-acc2-5070fee9be83",
    langCode: "fr-FR",
    stickerArt: [ 
        // NOTE: Currently using Twi sticker art as placeholders
        // See CR-008 (mobile) / French Content Incomplete: French-specific sticker art needs to be created by design team
        { unit: 1, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/fW4LOEf.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/epHob94.png' },
        { unit: 2, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/EuaLND6.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/JWt7fWV.png' },
        { unit: 3, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/ZyuIetF.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/2hcaJg5.png' },
        { unit: 4, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/mGZuxu6.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/Fbv0aoh.png' },
        { unit: 5, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/DWT8T9H.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/84OY2hg.png' },
        { unit: 6, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/1hhek1A.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/DPOfagS.png' },
        { unit: 7, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/dWh9HTZ.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/lHqijax.png' },
        { unit: 8, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/qo7qiTH.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/rJYEBev.png' },
        { unit: 9, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/lpIGNbz.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/oiRikoB.png' },
        { unit: 10, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/q41m9ts.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/W2xHFk3.png' },
        { unit: 11, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/3deJKYi.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/12ERqE9.png' },
        { unit: 12, unlocked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/6Oy3Ijw.png', locked: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/w8SaaOI.png' }, 
    ],
    wordList: [
        { translation: "Bonjour", english: "Hello / Good Morning", display: '👋🏾' }, // French uses one word for both contexts
        { translation: "Bienvenue", english: "Welcome", display: '🤗' },
        { translation: "Bon après-midi", english: "Good afternoon" },
        { translation: "Bonsoir", english: "Good evening" },
        { translation: "Au revoir", english: "Goodbye", display: '🫡' },
        { translation: "Bonne nuit", english: "Good night", display: '😴' },
        { translation: "À plus tard", english: "See you later", display: '👋🏾' },
        { translation: "Comment allez-vous ?", english: "How are you?" },
        { translation: "Je vais bien", english: "I am fine", display: '👍🏾' },
        { translation: "Merci", english: "Thank you", display: '🙏🏾' },
        { translation: "S'il vous plaît", english: "Please", display: '🙇🏾‍♀️' },
        { translation: "Oui", english: "Yes", display: '✅' },
        { translation: "Non", english: "No", display: '❌' },
        { translation: "Désolé", english: "Sorry", display: '😔' },
        { translation: "Ça va", english: "It's okay", display: '👍🏾' },
        { translation: "Je m'appelle...", english: "My name is...", display: '📣' },
        { translation: "Quel est votre nom ?", english: "What is your name?", display: '❓' },
        { translation: "D'où venez-vous ?", english: "Where are you from?" },
        { translation: "Je viens de...", english: "I am from...", display: '📍' },
        { translation: "Je t'aime", english: "I love you", display: '❤️' },
        { translation: "Fais-moi un câlin", english: "Hug me", display: '🫂' },
        { translation: "Pardonne-moi", english: "Forgive me", display: '🙏🏾' },
        { translation: "Aide-moi", english: "Help me", display: '🆘' },
        { translation: "Trouve-moi", english: "Find me", display: '🔍' },
    ],
    sentences: [
        { text: "Je m'appelle Jean", english: "My name is Jean" },
        { text: "Comment allez-vous ?", english: "How are you?" },
        { text: "Papa cuisine le repas", english: "Father is cooking food" },
        { text: "Maman lit un livre", english: "Mother is reading a book" },
        { text: "Le fermier joue", english: "The farmer is playing" },
        { text: "J'aime les oranges rouges", english: "I like red oranges" },
        { text: "La vache est grande", english: "The cow is big" },
        { text: "Le lion court", english: "The lion is running" },
        { text: "La nourriture est délicieuse", english: "The food is delicious" },
        { text: "S'il vous plaît, donnez-moi de l'eau", english: "Please, give me water" },
    ],
    moduleContent: {
        // UNIT 1: GREETINGS & SELF-INTRODUCTION
        
        // Cultural Note: Senegal
        'french_m1_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: Teranga',
            country: 'Senegal',
            flagEmoji: '🇸🇳',
            content: `Senegal is known as the "Land of Teranga" (Hospitality). It's a cultural philosophy of generosity where guests are treated like kings. It reflects a society that values human connection above all else.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit1_senegal.webp'
        },
        
        // Lesson 1
        'french_m1_lesson1_greetings': {
            content: [
                { word: "Bonjour", wordEnglish: "Hello / Good Morning", display: '👋🏾' },
                { word: "Bienvenue", wordEnglish: "Welcome", display: '🤗' },
                { word: "Bon après-midi", wordEnglish: "Good afternoon", display: '😎' },
                { word: "Bonsoir", wordEnglish: "Good evening", display: '🌙' },
                { word: "Au revoir", wordEnglish: "Goodbye", display: '🫡' },
                { word: "Bonne nuit", wordEnglish: "Good night", display: '😴' },
                { word: "À plus tard", wordEnglish: "See you later", display: '🫱🏾‍🫲🏽' }
            ],
            newWords: ['Bonjour', 'Bienvenue', 'Bon après-midi', 'Bonsoir', 'Au revoir', 'Bonne nuit', 'À plus tard']
        },
        'french_m1_quiz1_greetings': {
            quiz: [
                {
                    question: "What is 'Bonjour' in English?",
                    options: ["Goodbye", "Hello / Good Morning", "Good night", "Welcome"],
                    answer: "Hello / Good Morning"
                },
                {
                    question: "How do you say 'Goodbye' in French?",
                    options: ["Bonjour", "Bonsoir", "Au revoir", "Merci"],
                    answer: "Au revoir"
                },
                {
                    question: "What does 'Bonsoir' mean?",
                    options: ["Good morning", "Good evening", "Good afternoon", "Good night"],
                    answer: "Good evening"
                },
                {
                    question: "Which greeting would you use in the morning?",
                    options: ["Bonsoir", "Bonne nuit", "Bonjour", "Au revoir"],
                    answer: "Bonjour"
                },
                {
                    question: "What is 'Bienvenue'?",
                    options: ["Welcome", "Goodbye", "Hello", "Thank you"],
                    answer: "Welcome"
                }
            ],
            newWords: [] // Quizzes don't introduce new words
        },

        // Lesson 2
        'french_m1_lesson2_conversation': {
            content: [
                { word: "Comment allez-vous ?", wordEnglish: "How are you?", display: '🤔' },
                { word: "Je vais bien", wordEnglish: "I am fine", display: '👍🏾' },
                { word: "Merci", wordEnglish: "Thank you", display: '🙏🏾' },
                { word: "S'il vous plaît", wordEnglish: "Please", display: '🙇🏾‍♀️' },
                { word: "Oui", wordEnglish: "Yes", display: '✅' },
                { word: "Non", wordEnglish: "No", display: '❌' },
                { word: "Désolé", wordEnglish: "Sorry", display: '😔' },
                { word: "Ça va", wordEnglish: "It's okay", display: '👌🏾' }
            ],
            newWords: ['Comment allez-vous ?', 'Je vais bien', 'Merci', "S'il vous plaît", 'Oui', 'Non', 'Désolé', 'Ça va']
        },
        'french_m1_activity_convo1': {
            activityType: 'simpleConversation',
            content: [
                { prompt: 'Someone says: Bonjour.', options: ['Salut', 'Merci', 'Au revoir'], correct: 'Salut' },
                { prompt: 'Someone says: Comment allez-vous ?', options: ['Je vais bien', 'Oui', 'Non'], correct: 'Je vais bien' },
                { prompt: 'Character offers a gift, says: S\'il vous plaît.', options: ['Merci', 'Désolé', 'Non'], correct: 'Merci' },
                { prompt: 'You need to ask for something politely. You should say:', options: ['S\'il vous plaît', 'Je vais bien', 'Bienvenue'], correct: 'S\'il vous plaît' },
                { prompt: 'A character asks a yes/no question. To say "Yes", you tap:', options: ['Oui', 'Non', 'Ça va'], correct: 'Oui' },
                { prompt: 'A character asks a yes/no question. To say "No", you tap:', options: ['Non', 'Oui', 'Désolé'], correct: 'Non' },
                { prompt: 'Character bumps into you and says: Désolé. You reply:', options: ['Ça va', 'Merci', 'Je vais bien'], correct: 'Ça va' },
                { prompt: 'You bump into a character. You should say:', options: ['Désolé', 'Oui', 'Bonne nuit'], correct: 'Désolé' }
            ],
            newWords: [] // Activities practice existing words, don't introduce new ones
        },
        'french_m1_quiz2_conversation': {
            quiz: [
                {
                    question: "How do you say 'Thank you'?",
                    options: ["S'il vous plaît", "Merci", "Désolé"],
                    answer: "Merci"
                },
                {
                    question: "If someone asks 'Comment allez-vous?', how do you say 'I am fine'?",
                    options: ["Je vais bien", "Oui", "Non"],
                    answer: "Je vais bien"
                },
                {
                    question: "What does 'S'il vous plaît' mean?",
                    options: ["Sorry", "Please", "It's okay"],
                    answer: "Please"
                },
                {
                    question: "If someone says 'Désolé', what is a polite response?",
                    options: ["Oui", "Ça va", "Non"],
                    answer: "Ça va"
                },
                {
                    question: "Which word means 'Yes'?",
                    options: ["Désolé", "Merci", "Oui"],
                    answer: "Oui"
                }
            ],
            newWords: [] // Quizzes don't introduce new words
        },

        // Lesson 3
        'french_m1_lesson3_introduction': {
            content: [
                { word: "Je m'appelle...", wordEnglish: "My name is...", display: '📣' },
                { word: "Quel est votre nom ?", wordEnglish: "What is your name?", display: '❓' },
                { word: "D'où venez-vous ?", wordEnglish: "Where are you from?", display: '🌍' },
                { word: "Je viens de...", wordEnglish: "I am from...", display: '📍' },
                { word: "Enchanté", wordEnglish: "Nice to meet you", display: '🤝' },
                { word: "La nourriture est délicieuse", wordEnglish: "The food is delicious", display: '😋' },
                { word: "Fais-moi un câlin", wordEnglish: "Hug me", display: '🫂' },
                { word: "Je t'aime", wordEnglish: "I love you", display: '❤️' }
            ],
            newWords: ["Je m'appelle...", "Quel est votre nom ?", "D'où venez-vous ?", "Je viens de...", "Enchanté", "La nourriture est délicieuse", "Fais-moi un câlin", "Je t'aime"]
        },
        'french_m1_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'Merci', options: ['Thank you', 'Hello / Good Morning', 'Water', 'Dog'], correct: 'Thank you' },
                { audio: 'Bienvenue', options: ['Welcome', 'Goodbye', 'Yes', 'Mother'], correct: 'Welcome' },
                { audio: 'Je t\'aime', options: ['I love you', 'I am hungry', 'My name is', 'I am fine'], correct: 'I love you' },
                { audio: 'Fais-moi un câlin', options: ['Hug me', 'Help me', 'Forgive me', 'Find me'], correct: 'Hug me' },
                { audio: 'La nourriture est délicieuse', options: ['The food is delicious', 'The water is hot', 'The room is big', 'The story is good'], correct: 'The food is delicious' },
                { audio: 'Je m\'appelle...', options: ['My name is...', 'What is your name?', 'I am from...', 'I am fine'], correct: 'My name is...' },
                { audio: 'Ça va', options: ["It's okay", 'Sorry', 'Please', 'Yes'], correct: "It's okay" },
                { audio: 'À plus tard', options: ['See you later', 'Good night', 'Welcome', 'Hello / Good Morning'], correct: 'See you later' }
            ],
            newWords: [] // Activities practice existing words, don't introduce new ones
        },
        'french_m1_quiz3_introduction': {
            quiz: [
                {
                    question: "How would you ask 'What is your name?'",
                    options: ["Je m'appelle...", "Quel est votre nom ?", "D'où venez-vous ?"],
                    answer: "Quel est votre nom ?"
                },
                {
                    question: "To tell someone 'My name is...', you would start with:",
                    options: ["Je m'appelle...", "Je viens de...", "Je t'aime"],
                    answer: "Je m'appelle..."
                },
                {
                    question: "How do you say 'Nice to meet you'?",
                    options: ["Fais-moi un câlin", "Enchanté", "Je t'aime"],
                    answer: "Enchanté"
                },
                {
                    question: "How do you say 'I love you'?",
                    options: ["Fais-moi un câlin", "Je t'aime", "Je viens de..."],
                    answer: "Je t'aime"
                },
                {
                    question: "How do you ask 'Where are you from?'",
                    options: ["D'où venez-vous ?", "Quel est votre nom ?", "Je viens de..."],
                    answer: "D'où venez-vous ?"
                }
            ],
            newWords: [] // Quizzes don't introduce new words
        },

        // Review
        'french_m1_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 1 Review",
                sourceQuizzes: ['french_m1_quiz1_greetings', 'french_m1_quiz2_conversation', 'french_m1_quiz3_introduction']
            }
        },

        // ===== UNIT 2: FAMILY & COMMUNITY =====
        
        // Cultural Note: Mali
        'french_m2_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: The Golden Empire',
            country: 'Mali',
            flagEmoji: '🇲🇱',
            content: `Mali was once the home of the wealthiest man in history, Mansa Musa! The Mali Empire was a center of gold trade and learning, with vast libraries in Timbuktu that scholars visited from around the world.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit2_mali.webp'
        },
        
        // Lesson 1: My Core Family
        'french_m2_lesson1_core_family': {
            content: [
                { word: "Maman", wordEnglish: "Mother", display: '👩🏾' },
                { word: "Papa", wordEnglish: "Father", display: '👨🏾' },
                { word: "Frère", wordEnglish: "Brother", display: '👦🏾' },
                { word: "Sœur", wordEnglish: "Sister", display: '👧🏾' },
                { word: "Bébé", wordEnglish: "Baby", display: '👶🏾' },
                { word: "Femme", wordEnglish: "Wife", display: '👰🏾' },
                { word: "Famille", wordEnglish: "Family", display: '👨🏾‍👩🏾‍👧🏾‍👦🏾' },
                { word: "Mari", wordEnglish: "Husband", display: '🤵🏾' }
            ],
            newWords: ["Maman", "Papa", "Frère", "Sœur", "Bébé", "Femme", "Famille", "Mari"]
        },

        'french_m2_activity_sort1': {
            activityType: 'categorySort',
            content: {
                categories: ["Family", "Not Family"],
                items: [
                    { word: 'Maman', category: 'Family' },
                    { word: 'Papa', category: 'Family' },
                    { word: 'Bonjour', category: 'Not Family' },
                    { word: 'Sœur', category: 'Family' },
                    { word: 'Merci', category: 'Not Family' },
                    { word: 'Famille', category: 'Family' },
                    { word: 'Mari', category: 'Family' },
                    { word: 'Grand-mère', category: 'Family' }
                ]
            },
            newWords: [] // Activities practice existing words
        },

        'french_m2_quiz1_core_family': {
            quiz: [
                { question: 'How do you say "Mother"?', options: ['Papa', 'Maman', 'Sœur'], answer: 'Maman' },
                { question: 'How do you say your family?', options: ['Mari', 'Femme', 'Famille'], answer: 'Famille' },
                { question: 'What does "Frère" mean?', options: ['Sister', 'Brother', 'Father'], answer: 'Brother' },
                { question: 'The word for "Wife" is:', options: ['Femme', 'Bébé', 'Mari'], answer: 'Femme' },
                { question: 'Your "Papa" is your:', options: ['Husband', 'Baby', 'Father'], answer: 'Father' }
            ],
            newWords: [] // Quizzes don't introduce new words
        },

        // Lesson 2: My Extended Family
        'french_m2_lesson2_extended_family': {
            content: [
                { word: "Grand-mère", wordEnglish: "Grandmother", display: '👵🏾' },
                { word: "Grand-père", wordEnglish: "Grandfather", display: '👴🏾' },
                { word: "Tante", wordEnglish: "Aunt", display: '👩🏾‍🦱' },
                { word: "Beau-père", wordEnglish: "Father-in-law", display: '👴🏾' },
                { word: "Garçon", wordEnglish: "Boy", display: '👦🏾' },
                { word: "Fille", wordEnglish: "Girl", display: '👧🏾' },
                { word: "Aîné", wordEnglish: "Elder", display: '🧓🏾' },
                { word: "Belle-mère", wordEnglish: "Mother-in-law", display: '👵🏾' }
            ],
            newWords: ["Grand-mère", "Grand-père", "Tante", "Beau-père", "Garçon", "Fille", "Aîné", "Belle-mère"]
        },

        'french_m2_quiz2_extended_family': {
            quiz: [
                { question: 'Your spouse\'s father is your:', options: ['Grand-père', 'Beau-père', 'Tante'], answer: 'Beau-père' },
                { question: 'A respected older person in the community is an:', options: ['Fille', 'Aîné', 'Garçon'], answer: 'Aîné' },
                { question: 'How do you say "Grandmother"?', options: ['Grand-mère', 'Grand-père', 'Maman'], answer: 'Grand-mère' },
                { question: 'How do you say "Mother-in-law"?', options: ['Aîné', 'Belle-mère', 'Tante'], answer: 'Belle-mère' },
                { question: 'What does "Fille" mean in English?', options: ['Boy', 'Girl', 'Aunt'], answer: 'Girl' }
            ],
            newWords: [] // Quizzes don't introduce new words
        },

        // Lesson 3: People in My Community
        'french_m2_lesson3_community': {
            content: [
                { word: "Enseignant", wordEnglish: "Teacher", display: '👩🏾‍🏫' },
                { word: "Docteur", wordEnglish: "Doctor", display: '🧑🏾‍⚕️' },
                { word: "Fermier", wordEnglish: "Farmer", display: '🧑🏾‍🌾' },
                { word: "Policier", wordEnglish: "Police Officer", display: '👮🏾' },
                { word: "Cuisinier", wordEnglish: "Cook / Chef", display: '🧑🏾‍🍳' },
                { word: "Commerçant", wordEnglish: "Trader / Seller", display: '🏪' },
                { word: "Pilote", wordEnglish: "Pilot", display: '🧑🏾‍✈️' },
                { word: "Pompier", wordEnglish: "Firefighter", display: '🧑🏾‍🚒' }
            ],
            newWords: ["Enseignant", "Docteur", "Fermier", "Policier", "Cuisinier", "Commerçant", "Pilote", "Pompier"]
        },

        'french_m2_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'Grand-mère', options: ['Grandmother', 'Grandfather', 'Aunt', 'Doctor'], correct: 'Grandmother' },
                { audio: 'Enseignant', options: ['Teacher', 'Doctor', 'Farmer', 'Police Officer'], correct: 'Teacher' },
                { audio: 'Fille', options: ['Girl', 'Boy', 'Baby', 'Elder'], correct: 'Girl' },
                { audio: 'Chef', options: ['King / Chief', 'Farmer', 'Teacher', 'Pilot'], correct: 'King / Chief' },
                { audio: 'Docteur', options: ['Doctor', 'Aunt', 'Mother', 'Father'], correct: 'Doctor' },
                { audio: 'Fermier', options: ['Farmer', 'Cook', 'Police Officer', 'Doctor'], correct: 'Farmer' },
                { audio: 'Ami', options: ['Friend', 'Brother', 'Sister', 'Family'], correct: 'Friend' },
                { audio: 'Aîné', options: ['Elder', 'Farmer', 'Baby', 'Girl'], correct: 'Elder' }
            ],
            newWords: [] // Activities practice existing words
        },

        'french_m2_quiz3_community': {
            quiz: [
                { question: 'A person who grows food is called an:', options: ['Enseignant', 'Fermier', 'Docteur'], answer: 'Fermier' },
                { question: 'Who helps you when you are sick?', options: ['Policier', 'Cuisinier', 'Docteur'], answer: 'Docteur' },
                { question: 'How do you say "Teacher"?', options: ['Commerçant', 'Pilote', 'Enseignant'], answer: 'Enseignant' },
                { question: 'A person who flies an aeroplane is a pilot, or:', options: ['Pompier', 'Pilote', 'Policier'], answer: 'Pilote' },
                { question: 'Who would you find at a market stall?', options: ['Commerçant', 'Docteur', 'Fermier'], answer: 'Commerçant' }
            ],
            newWords: [] // Quizzes don't introduce new words
        },

        'french_m2_activity_convo1': {
            activityType: 'simpleConversation',
            content: [
                { prompt: "Someone shows picture of a woman, asks: Qui est-ce?", options: ["C'est ma mère", "C'est mon père", "C'est mon frère"], correct: "C'est ma mère" },
                { prompt: "Someone shows picture of a man, asks: Qui est-ce?", options: ["C'est mon père", "C'est ma mère", "C'est mon oncle"], correct: "C'est mon père" },
                { prompt: "Someone shows picture of a boy, asks: Qui est-ce?", options: ["C'est mon frère", "C'est ma sœur", "C'est un ami"], correct: "C'est mon frère" },
                { prompt: "Someone shows picture of a girl, asks: Qui est-ce?", options: ["C'est ma sœur", "C'est mon frère", "C'est ma tante"], correct: "C'est ma sœur" },
                { prompt: "Someone asks: As-tu une sœur?", options: ["Oui, j'en ai une", "Non, je n'en ai pas", "Merci"], correct: ["Oui, j'en ai une", "Non, je n'en ai pas"] },
                { prompt: "Someone asks: Comment t'appelles-tu?", options: ["Je m'appelle [User's Name]", "Je vais bien", "Je viens de..."], correct: "Je m'appelle [User's Name]" },
                { prompt: "Someone shows picture of a family, asks: C'est une famille?", options: ["Oui, c'est une famille", "Non, ce n'est pas", "Je veux..."], correct: "Oui, c'est une famille" },
                { prompt: "Someone asks: Tu aimes ta famille?", options: ["Oui, j'aime ma famille", "Non, je n'aime pas", "À bientôt"], correct: "Oui, j'aime ma famille" }
            ],
            newWords: [] // Activities practice existing words
        },

        'french_m2_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 2 Review",
                sourceQuizzes: ['french_m2_quiz1_core_family', 'french_m2_quiz2_extended_family', 'french_m2_quiz3_community']
            }
        },

        // ===== UNIT 3: COLORS & NUMBERS =====
        
        // Cultural Note: General
        'french_m3_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: Mobile Money',
            country: 'Pan-African',
            flagEmoji: '🌍',
            content: `Francophone Africa is a leader in FinTech! Mobile money systems are revolutionizing banking, allowing entrepreneurs in cities like Abidjan and Dakar to build businesses with just a phone.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit3_mobile_money.webp'
        },
        
        // Lesson 1: Counting from 1 to 10
        'french_m3_lesson1_numbers1_10': {
            content: [
                { word: "Un", wordEnglish: "One", display: '1️⃣' },
                { word: "Deux", wordEnglish: "Two", display: '2️⃣' },
                { word: "Trois", wordEnglish: "Three", display: '3️⃣' },
                { word: "Quatre", wordEnglish: "Four", display: '4️⃣' },
                { word: "Cinq", wordEnglish: "Five", display: '5️⃣' },
                { word: "Six", wordEnglish: "Six", display: '6️⃣' },
                { word: "Sept", wordEnglish: "Seven", display: '7️⃣' },
                { word: "Huit", wordEnglish: "Eight", display: '8️⃣' },
                { word: "Neuf", wordEnglish: "Nine", display: '9️⃣' },
                { word: "Dix", wordEnglish: "Ten", display: '🔟' }
            ],
            newWords: ["Un", "Deux", "Trois", "Quatre", "Cinq", "Six", "Sept", "Huit", "Neuf", "Dix"]
        },

        'french_m3_activity_match1': {
            activityType: 'numberMatch',
            content: [
                { prompt: "5", options: ['Cinq', 'Six', 'Sept'], correct: 'Cinq' },
                { prompt: "8", options: ['Dix', 'Huit', 'Un'], correct: 'Huit' },
                { prompt: "3", options: ['Trois', 'Quatre', 'Deux'], correct: 'Trois' },
                { prompt: "10", options: ['Neuf', 'Dix', 'Onze'], correct: 'Dix' },
                { prompt: "1", options: ['Un', 'Deux', 'Quatre'], correct: 'Un' },
                { prompt: "6", options: ['Cinq', 'Six', 'Sept'], correct: 'Six' },
                { prompt: "12", options: ['Vingt', 'Onze', 'Douze'], correct: 'Douze' },
                { prompt: "20", options: ['Trente', 'Dix', 'Vingt'], correct: 'Vingt' }
            ],
            newWords: [] // Activities practice existing words
        },

        'french_m3_quiz1_numbers1_10': {
            quiz: [
                { question: 'How do you say "Five"?', options: ['Quatre', 'Cinq', 'Six'], answer: 'Cinq' },
                { question: 'What number is "Deux"?', options: ['One', 'Two', 'Three'], answer: 'Two' },
                { question: 'What number comes after "Neuf" (Nine)?', options: ['Huit', 'Onze', 'Dix'], answer: 'Dix' },
                { question: 'How do you say "One"?', options: ['Un', 'Sept', 'Quatre'], answer: 'Un' },
                { question: 'Which of these means "Eight"?', options: ['Six', 'Sept', 'Huit'], answer: 'Huit' }
            ],
            newWords: [] // Quizzes don't introduce new words
        },

        // Lesson 2: Learning My Colors
        'french_m3_lesson2_colors': {
            content: [
                { word: "Rouge", wordEnglish: "Red", display: '🔴' },
                { word: "Noir", wordEnglish: "Black", display: '⚫' },
                { word: "Blanc", wordEnglish: "White", display: '⚪' },
                { word: "Jaune", wordEnglish: "Yellow", display: '🟡' },
                { word: "Bleu", wordEnglish: "Blue", display: '🔵' },
                { word: "Vert", wordEnglish: "Green", display: '🟢' },
                { word: "Marron", wordEnglish: "Brown", display: '🟤' },
                { word: "Orange", wordEnglish: "Orange", display: '🟠' }
            ],
            newWords: ["Rouge", "Noir", "Blanc", "Jaune", "Bleu", "Vert", "Marron", "Orange"]
        },

        'french_m3_colormatch': {
            activityType: 'colorMatch',
            content: [
                { prompt: 'Rouge', options: ['Red', 'Blue', 'Green', 'Yellow'], correct: 'Red' },
                { prompt: 'Noir', options: ['White', 'Black', 'Yellow', 'Orange'], correct: 'Black' },
                { prompt: 'Blanc', options: ['White', 'Grey', 'Brown', 'Pink'], correct: 'White' },
                { prompt: 'Jaune', options: ['Orange', 'Yellow', 'Red', 'Green'], correct: 'Yellow' },
                { prompt: 'Bleu', options: ['Green', 'Purple', 'Blue', 'Red'], correct: 'Blue' },
                { prompt: 'Vert', options: ['Green', 'Yellow', 'Blue', 'Black'], correct: 'Green' },
                { prompt: 'Violet', options: ['Pink', 'Purple', 'Blue', 'Grey'], correct: 'Purple' },
                { prompt: 'Rose', options: ['Pink', 'Purple', 'Orange', 'Red'], correct: 'Pink' }
            ],
            newWords: [] // Activities practice existing words
        },

        'french_m3_quiz2_colors': {
            quiz: [
                { question: 'The color of a ripe tomato is:', options: ['Bleu', 'Rouge', 'Noir'], answer: 'Rouge' },
                { question: 'What does "Vert" mean?', options: ['Green', 'Yellow', 'White'], answer: 'Green' },
                { question: 'How do you say the color "Black"?', options: ['Blanc', 'Marron', 'Noir'], answer: 'Noir' },
                { question: 'The sky is often what color?', options: ['Rouge', 'Bleu', 'Orange'], answer: 'Bleu' },
                { question: 'How do you say "White"?', options: ['Blanc', 'Noir', 'Jaune'], answer: 'Blanc' }
            ],
            newWords: [] // Quizzes don't introduce new words
        },

        // Lesson 3: Bigger Numbers & More Colors
        'french_m3_lesson3_more_numbers_colors': {
            content: [
                { word: "Onze", wordEnglish: "Eleven", display: '1️⃣1️⃣' },
                { word: "Douze", wordEnglish: "Twelve", display: '1️⃣2️⃣' },
                { word: "Vingt", wordEnglish: "Twenty", display: '2️⃣0️⃣' },
                { word: "Violet", wordEnglish: "Purple", display: '🟣' },
                { word: "Rose", wordEnglish: "Pink", display: '🌸' },
                { word: "Gris", wordEnglish: "Grey", display: '🐘' }
            ],
            newWords: ["Onze", "Douze", "Vingt", "Violet", "Rose", "Gris"]
        },

        'french_m3_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'Rouge', options: ['Red swatch', 'Blue swatch', 'Green swatch', 'Yellow swatch'], correct: 'Red swatch' },
                { audio: 'Vingt', options: ['20', '12', '15', '30'], correct: '20' },
                { audio: 'Noir', options: ['Black swatch', 'White swatch', 'Brown swatch', 'Orange swatch'], correct: 'Black swatch' },
                { audio: 'Trois', options: ['3', '4', '5', '6'], correct: '3' },
                { audio: 'Vert', options: ['Green swatch', 'Purple swatch', 'Pink swatch', 'Grey swatch'], correct: 'Green swatch' },
                { audio: 'Onze', options: ['11', '10', '13', '14'], correct: '11' },
                { audio: 'Bleu', options: ['Blue swatch', 'Red swatch', 'Yellow swatch', 'Black swatch'], correct: 'Blue swatch' },
                { audio: 'Neuf', options: ['9', '8', '7', '6'], correct: '9' }
            ],
            newWords: [] // Activities practice existing words
        },

        'french_m3_quiz3_more_numbers_colors': {
            quiz: [
                { question: 'How do you say "Eleven"?', options: ['Dix', 'Onze', 'Douze'], answer: 'Onze' },
                { question: 'What number is "Vingt"?', options: ['Twelve', 'Fifteen', 'Twenty'], answer: 'Twenty' },
                { question: 'The color "Violet" is known as what in English?', options: ['Pink', 'Grey', 'Purple'], answer: 'Purple' },
                { question: 'How do you say "Twelve"?', options: ['Douze', 'Treize', 'Quinze'], answer: 'Douze' },
                { question: 'An elephant is often "Gris", which means:', options: ['Pink', 'Grey', 'Purple'], answer: 'Grey' }
            ],
            newWords: [] // Quizzes don't introduce new words
        },

        'french_m3_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 3 Review",
                sourceQuizzes: ['french_m3_quiz1_numbers1_10', 'french_m3_quiz2_colors', 'french_m3_quiz3_more_numbers_colors']
            }
        },

        // ===== UNIT 4: ANIMALS & NATURE =====
        
        // Cultural Note: DRC (Congo)
        'french_m4_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: Ecological Superpower',
            country: 'Democratic Republic of Congo',
            flagEmoji: '🇨🇩',
            content: `The Congo Basin is the "second lung of the earth." Its massive rainforests absorb carbon and protect the entire planet. It is a global treasure of biodiversity and life.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit4_drc.webp'
        },
        
        'french_m4_lesson1_farm_animals': {
            content: [
                { word: "Chien", wordEnglish: "Dog", display: '🐕' },
                { word: "Chat", wordEnglish: "Cat", display: '🐈' },
                { word: "Poulet", wordEnglish: "Chicken", display: '🐔' },
                { word: "Chèvre", wordEnglish: "Goat", display: '🐐' },
                { word: "Mouton", wordEnglish: "Sheep", display: '🐑' },
                { word: "Vache", wordEnglish: "Cow", display: '🐄' },
                { word: "Cochon", wordEnglish: "Pig", display: '🐖' },
                { word: "Cheval", wordEnglish: "Horse", display: '🐎' }
            ],
            newWords: ["Chien", "Chat", "Poulet", "Chèvre", "Mouton", "Vache", "Cochon", "Cheval"]
        },

        'french_m4_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'Chien', options: ['Dog', 'Cat', 'Pig', 'Cow'], correct: 'Dog' },
                { audio: 'Poulet', options: ['Goat', 'Chicken', 'Sheep', 'Horse'], correct: 'Chicken' },
                { audio: 'Vache', options: ['Dog', 'Cow', 'Pig', 'Cat'], correct: 'Cow' },
                { audio: 'Mouton', options: ['Sheep', 'Goat', 'Horse', 'Chicken'], correct: 'Sheep' },
                { audio: 'Chèvre', options: ['Goat', 'Sheep', 'Pig', 'Horse'], correct: 'Goat' },
                { audio: 'Cochon', options: ['Pig', 'Dog', 'Cat', 'Chicken'], correct: 'Pig' },
                { audio: 'Cheval', options: ['Horse', 'Cow', 'Goat', 'Sheep'], correct: 'Horse' },
                { audio: 'Chat', options: ['Cat', 'Dog', 'Chicken', 'Pig'], correct: 'Cat' }
            ],
            newWords: []
        },

        'french_m4_quiz1_farm_animals': {
            quiz: [
                { question: 'How do you say "Goat"?', options: ['Mouton', 'Chèvre', 'Poulet'], answer: 'Chèvre' },
                { question: 'A "Vache" is a large farm animal that gives us milk. What is it?', options: ['Horse', 'Pig', 'Cow'], answer: 'Cow' },
                { question: 'How do you say "Dog"?', options: ['Chat', 'Chien', 'Cochon'], answer: 'Chien' },
                { question: 'Which of these is a "Cat"?', options: ['Chat', 'Mouton', 'Cheval'], answer: 'Chat' },
                { question: 'A "Poulet" lays eggs. What is it?', options: ['Pig', 'Sheep', 'Chicken'], answer: 'Chicken' }
            ],
            newWords: []
        },

        'french_m4_lesson2_wild_animals': {
            content: [
                { word: "Lion", wordEnglish: "Lion", display: '🦁' },
                { word: "Éléphant", wordEnglish: "Elephant", display: '🐘' },
                { word: "Singe", wordEnglish: "Monkey", display: '🐒' },
                { word: "Serpent", wordEnglish: "Snake", display: '🐍' },
                { word: "Araignée", wordEnglish: "Spider", display: '🕷️' },
                { word: "Léopard", wordEnglish: "Leopard", display: '🐆' },
                { word: "Crocodile", wordEnglish: "Crocodile", display: '🐊' },
                { word: "Tortue", wordEnglish: "Tortoise", display: '🐢' }
            ],
            newWords: ["Lion", "Éléphant", "Singe", "Serpent", "Araignée", "Léopard", "Crocodile", "Tortue"]
        },

        'french_m4_activity_sort1': {
            activityType: 'categorySort',
            content: {
                categories: ["Farm Animals", "Wild Animals"],
                items: [
                    { word: 'Vache', category: 'Farm Animals' },
                    { word: 'Lion', category: 'Wild Animals' },
                    { word: 'Poulet', category: 'Farm Animals' },
                    { word: 'Éléphant', category: 'Wild Animals' },
                    { word: 'Léopard', category: 'Wild Animals' },
                    { word: 'Mouton', category: 'Farm Animals' },
                    { word: 'Cochon', category: 'Farm Animals' },
                    { word: 'Singe', category: 'Wild Animals' }
                ]
            },
            newWords: []
        },

        'french_m4_quiz2_wild_animals': {
            quiz: [
                { question: 'The king of the jungle is called a "Lion". What is it?', options: ['Elephant', 'Lion', 'Leopard'], answer: 'Lion' },
                { question: 'An "Araignée" is a small creature with eight legs. What is it?', options: ['Monkey', 'Tortoise', 'Spider'], answer: 'Spider' },
                { question: 'How do you say "Elephant"?', options: ['Léopard', 'Éléphant', 'Crocodile'], answer: 'Éléphant' },
                { question: 'What does "Serpent" mean?', options: ['Snake', 'Monkey', 'Crocodile'], answer: 'Snake' },
                { question: 'A "Tortue" is known for being slow. What is it?', options: ['Leopard', 'Tortoise', 'Spider'], answer: 'Tortoise' }
            ],
            newWords: []
        },

        'french_m4_lesson3_nature': {
            content: [
                { word: "Arbre", wordEnglish: "Tree", display: '🌳' },
                { word: "Fleur", wordEnglish: "Flower", display: '🌸' },
                { word: "Rivière", wordEnglish: "River", display: '🏞️' },
                { word: "Soleil", wordEnglish: "Sun", display: '☀️' },
                { word: "Lune", wordEnglish: "Moon", display: '🌙' },
                { word: "Étoile", wordEnglish: "Star", display: '⭐' }
            ],
            newWords: ["Arbre", "Fleur", "Rivière", "Soleil", "Lune", "Étoile"]
        },

        'french_m4_quiz3_nature': {
            quiz: [
                { question: 'How do you say "Sun"?', options: ['Lune', 'Soleil', 'Étoile'], answer: 'Soleil' },
                { question: 'A large, flowing body of water is called a:', options: ['Mer', 'Rivière', 'Montagne'], answer: 'Rivière' },
                { question: 'How do you say "Tree"?', options: ['Arbre', 'Fleur', 'Montagne'], answer: 'Arbre' },
                { question: 'An "Étoile" shines at night. What is it?', options: ['Moon', 'Star', 'Cloud'], answer: 'Star' },
                { question: 'How do you say "Flower"?', options: ['Fleur', 'Rivière', 'Vent'], answer: 'Fleur' }
            ],
            newWords: []
        },

        'french_m4_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 4 Review",
                sourceQuizzes: ['french_m4_quiz1_farm_animals', 'french_m4_quiz2_wild_animals', 'french_m4_quiz3_nature']
            }
        },

        // ===== UNIT 5: FOOD & DRINK =====
        
        // Cultural Note: Ivory Coast
        'french_m5_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: The Cocoa Giant',
            country: 'Côte d\'Ivoire',
            flagEmoji: '🇨🇮',
            content: `Côte d'Ivoire is the world's #1 producer of cocoa! The chocolate enjoyed around the globe starts here. It is a land of immense agricultural wealth and fertile soil.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit5_ivory_coast.webp'
        },
        
        'french_m5_lesson1_staple_foods': {
            content: [
                { word: "Eau", wordEnglish: "Water", display: '💧' },
                { word: "Riz", wordEnglish: "Rice", display: '🍚' },
                { word: "Igname", wordEnglish: "Yam", display: '🍠' },
                { word: "Plantain", wordEnglish: "Plantain", display: '🍌' },
                { word: "Pain", wordEnglish: "Bread", display: '🍞' },
                { word: "Soupe", wordEnglish: "Soup", display: '🥣' },
                { word: "Viande", wordEnglish: "Meat", display: '🍖' },
                { word: "Poisson", wordEnglish: "Fish", display: '🐟' }
            ],
            newWords: ["Eau", "Riz", "Igname", "Plantain", "Pain", "Soupe", "Viande", "Poisson"]
        },

        'french_m5_quiz1_staple_foods': {
            quiz: [
                { question: 'How do you say "Water"?', options: ['Riz', 'Eau', 'Soupe'], answer: 'Eau' },
                { question: 'A popular food often made from "Igname". What is "Igname"?', options: ['Bread', 'Yam', 'Meat'], answer: 'Yam' },
                { question: 'How do you say "Rice"?', options: ['Poisson', 'Riz', 'Plantain'], answer: 'Riz' },
                { question: 'A popular side dish is fried "Plantain". What is it?', options: ['Plantain', 'Fish', 'Soup'], answer: 'Plantain' },
                { question: 'What does "Viande" mean?', options: ['Soup', 'Meat', 'Bread'], answer: 'Meat' }
            ],
            newWords: []
        },

        'french_m5_lesson2_fruits_vegetables': {
            content: [
                { word: "Orange", wordEnglish: "Orange", display: '🍊' },
                { word: "Tomate", wordEnglish: "Tomato", display: '🍅' },
                { word: "Banane", wordEnglish: "Banana", display: '🍌' },
                { word: "Oignon", wordEnglish: "Onion", display: '🧅' },
                { word: "Ananas", wordEnglish: "Pineapple", display: '🍍' },
                { word: "Poivron", wordEnglish: "Pepper", display: '🌶️' },
                { word: "Maïs", wordEnglish: "Corn", display: '🌽' },
                { word: "Avocat", wordEnglish: "Avocado", display: '🥑' },
                { word: "Noix de coco", wordEnglish: "Coconut", display: '🥥' }
            ],
            newWords: ["Orange", "Tomate", "Banane", "Oignon", "Ananas", "Poivron", "Maïs", "Avocat", "Noix de coco"]
        },

        'french_m5_activity_sort1': {
            activityType: 'categorySort',
            content: {
                categories: ["Fruits", "Vegetables"],
                items: [
                    { word: 'Orange', category: 'Fruits' },
                    { word: 'Tomate', category: 'Vegetables' },
                    { word: 'Banane', category: 'Fruits' },
                    { word: 'Oignon', category: 'Vegetables' },
                    { word: 'Ananas', category: 'Fruits' },
                    { word: 'Poivron', category: 'Vegetables' },
                    { word: 'Avocat', category: 'Fruits' },
                    { word: 'Noix de coco', category: 'Fruits' }
                ]
            },
            newWords: []
        },

        'french_m5_quiz2_fruits_vegetables': {
            quiz: [
                { question: 'How do you say "Banana"?', options: ['Orange', 'Banane', 'Poivron'], answer: 'Banane' },
                { question: 'An "Oignon" is a vegetable that can make you cry when you cut it. What is it?', options: ['Orange', 'Pineapple', 'Onion'], answer: 'Onion' },
                { question: 'Which of these is used to make food spicy?', options: ['Oignon', 'Tomate', 'Poivron'], answer: 'Poivron' },
                { question: 'How do you say "Pineapple"?', options: ['Ananas', 'Noix de coco', 'Avocat'], answer: 'Ananas' },
                { question: 'What is a "Tomate"?', options: ['Onion', 'Corn', 'Tomato'], answer: 'Tomato' }
            ],
            newWords: []
        },

        'french_m5_lesson3_eating_phrases': {
            content: [
                { word: "Manger", wordEnglish: "To eat", display: '😋' },
                { word: "Boire", wordEnglish: "To drink", display: '🥤' },
                { word: "Cuisiner", wordEnglish: "To cook", display: '🧑🏾‍🍳' },
                { word: "J'ai faim", wordEnglish: "I am hungry", display: '🍽️' },
                { word: "J'ai soif", wordEnglish: "I am thirsty", display: '💧' },
                { word: "Je suis rassasié", wordEnglish: "I am full", display: '😊' }
            ],
            newWords: ["Manger", "Boire", "Cuisiner", "J'ai faim", "J'ai soif", "Je suis rassasié"]
        },

        'french_m5_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'Riz', options: ['Rice', 'Yam', 'Bread', 'Soup'], correct: 'Rice' },
                { audio: 'Orange', options: ['Orange', 'Banana', 'Pineapple', 'Coconut'], correct: 'Orange' },
                { audio: 'Soupe', options: ['Soup', 'Water', 'Meat', 'Fish'], correct: 'Soup' },
                { audio: 'Eau', options: ['Water', 'Milk', 'Juice', 'Tea'], correct: 'Water' },
                { audio: 'Banane', options: ['Banana', 'Orange', 'Pineapple', 'Avocado'], correct: 'Banana' },
                { audio: 'Tomate', options: ['Tomato', 'Onion', 'Pepper', 'Corn'], correct: 'Tomato' },
                { audio: 'Igname', options: ['Yam', 'Rice', 'Plantain', 'Bread'], correct: 'Yam' },
                { audio: 'Viande', options: ['Meat', 'Fish', 'Soup', 'Water'], correct: 'Meat' }
            ],
            newWords: []
        },

        'french_m5_quiz3_eating_phrases': {
            quiz: [
                { question: 'When your tummy is empty, you say:', options: ['Je suis rassasié', "J'ai soif", "J'ai faim"], answer: "J'ai faim" },
                { question: 'What does "Manger" mean?', options: ['To drink', 'To cook', 'To eat'], answer: 'To eat' },
                { question: 'After eating a big meal and you don\'t want more food, you say:', options: ["J'ai faim", 'Je suis rassasié', 'Je veux de l\'eau'], answer: 'Je suis rassasié' },
                { question: 'If you need water, you would say:', options: ["J'ai soif", 'Cuisiner', 'Je veux...'], answer: "J'ai soif" },
                { question: 'Which word means "To cook"?', options: ['Boire', 'Cuisiner', 'Manger'], answer: 'Cuisiner' }
            ],
            newWords: []
        },

        'french_m5_activity_convo1': {
            activityType: 'simpleConversation',
            content: [
                { prompt: "Someone asks: As-tu faim?", options: ["Oui, j'ai faim", 'Non, je suis rassasié', 'Je veux de l\'eau'], correct: "Oui, j'ai faim" },
                { prompt: "Someone asks: As-tu soif?", options: ["Oui, j'ai soif", "Non, j'ai faim", 'Merci'], correct: "Oui, j'ai soif" },
                { prompt: "Someone points to rice, asks: Veux-tu du riz?", options: ['Oui, je veux', 'Non, je ne veux pas', 'Je vais bien'], correct: ['Oui, je veux', 'Non, je ne veux pas'] },
                { prompt: "Someone eats, says: La nourriture est délicieuse. You should agree.", options: ["Oui, c'est très bon", "Non, ce n'est pas bon", 'Désolé'], correct: "Oui, c'est très bon" },
                { prompt: "You are full. You say:", options: ['Je suis rassasié', "J'ai faim", 'Je veux plus'], correct: 'Je suis rassasié' },
                { prompt: "You want to drink. You say:", options: ['Je veux boire', 'Je veux manger', 'Je vais dormir'], correct: 'Je veux boire' },
                { prompt: "Your father is cooking. You say:", options: ['Papa cuisine', 'Maman cuisine', 'Je cuisine'], correct: 'Papa cuisine' },
                { prompt: "You want to thank someone for food. You say:", options: ['Merci', 'Au revoir', 'Bonjour'], correct: 'Merci' }
            ],
            newWords: []
        },

        'french_m5_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 5 Review",
                sourceQuizzes: ['french_m5_quiz1_staple_foods', 'french_m5_quiz2_fruits_vegetables', 'french_m5_quiz3_eating_phrases']
            }
        },

        // ===== UNIT 6: MY BODY & ACTIONS =====
        
        // Cultural Note: General
        'french_m6_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: Afro-Dance',
            country: 'Pan-African',
            flagEmoji: '🌍',
            content: `From Coupé-Décalé in Abidjan to Ndombolo in Congo, Francophone Africa is the dance floor of the world! These modern dance styles have influenced pop culture globally.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit6_dance.webp'
        },
        
        'french_m6_lesson1_head_face': {
            content: [
                { word: "Tête", wordEnglish: "Head", display: '👤' },
                { word: "Cheveux", wordEnglish: "Hair", display: '💇🏾‍♀️' },
                { word: "Œil", wordEnglish: "Eye", display: '👀' },
                { word: "Oreille", wordEnglish: "Ear", display: '👂🏾' },
                { word: "Nez", wordEnglish: "Nose", display: '👃🏾' },
                { word: "Bouche", wordEnglish: "Mouth", display: '👄' },
                { word: "Dent", wordEnglish: "Tooth", display: '🦷' },
                { word: "Visage", wordEnglish: "Face", display: '😊' }
            ],
            newWords: ["Tête", "Cheveux", "Œil", "Oreille", "Nez", "Bouche", "Dent", "Visage"]
        },

        'french_m6_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'Œil', options: ['Eye', 'Ear', 'Nose', 'Mouth'], correct: 'Eye' },
                { audio: 'Oreille', options: ['Ear', 'Eye', 'Nose', 'Mouth'], correct: 'Ear' },
                { audio: 'Nez', options: ['Nose', 'Mouth', 'Eye', 'Ear'], correct: 'Nose' },
                { audio: 'Bouche', options: ['Mouth', 'Nose', 'Tooth', 'Eye'], correct: 'Mouth' },
                { audio: 'Tête', options: ['Head', 'Hand', 'Foot', 'Arm'], correct: 'Head' },
                { audio: 'Cheveux', options: ['Hair', 'Face', 'Tooth', 'Ear'], correct: 'Hair' },
                { audio: 'Dent', options: ['Tooth', 'Mouth', 'Nose', 'Eye'], correct: 'Tooth' },
                { audio: 'Visage', options: ['Face', 'Head', 'Hair', 'Ear'], correct: 'Face' }
            ],
            newWords: []
        },

        'french_m6_quiz1_head_face': {
            quiz: [
                { question: 'What do you use to see?', options: ['Nez', 'Œil', 'Oreille'], answer: 'Œil' },
                { question: 'How do you say "Nose"?', options: ['Bouche', 'Oreille', 'Nez'], answer: 'Nez' },
                { question: 'What do you use to hear?', options: ['Œil', 'Oreille', 'Bouche'], answer: 'Oreille' },
                { question: 'How do you say "Mouth"?', options: ['Bouche', 'Nez', 'Visage'], answer: 'Bouche' },
                { question: 'You smile with your teeth, which are called:', options: ['Dent', 'Lèvre', 'Langue'], answer: 'Dent' }
            ],
            newWords: []
        },

        'french_m6_lesson2_arms_legs': {
            content: [
                { word: "Bras", wordEnglish: "Arm", display: '💪🏾' },
                { word: "Main", wordEnglish: "Hand", display: '✋🏾' },
                { word: "Jambe", wordEnglish: "Leg", display: '🦵🏾' },
                { word: "Pied", wordEnglish: "Foot", display: '🦶🏾' },
                { word: "Doigts", wordEnglish: "Fingers", display: '🖐🏾' },
                { word: "Ventre", wordEnglish: "Stomach", display: '🤰🏾' }
            ],
            newWords: ["Bras", "Main", "Jambe", "Pied", "Doigts", "Ventre"]
        },

        'french_m6_quiz2_arms_legs': {
            quiz: [
                { question: 'You use your "Jambe" to walk. What is it?', options: ['Arm', 'Hand', 'Leg'], answer: 'Leg' },
                { question: 'How do you say "Hand"?', options: ['Bras', 'Main', 'Pied'], answer: 'Main' },
                { question: 'How do you say your stomach?', options: ['Dos', 'Doigts', 'Ventre'], answer: 'Ventre' },
                { question: 'What are "Doigts"?', options: ['Fingers', 'Toes', 'Foot'], answer: 'Fingers' },
                { question: 'The word "Bras" means:', options: ['Back', 'Arm', 'Leg'], answer: 'Arm' }
            ],
            newWords: []
        },

        'french_m6_lesson3_action_words': {
            content: [
                { word: "Courir", wordEnglish: "To run", display: '🏃🏾‍♀️' },
                { word: "Marcher", wordEnglish: "To walk", display: '🚶🏾‍♀️' },
                { word: "Sauter", wordEnglish: "To jump", display: '🤸🏾‍♀️' },
                { word: "Danser", wordEnglish: "To dance", display: '💃🏾' },
                { word: "Chanter", wordEnglish: "To sing", display: '🎤' },
                { word: "Dormir", wordEnglish: "To sleep", display: '😴' },
                { word: "Jouer", wordEnglish: "To play", display: '🎲' },
                { word: "Lire", wordEnglish: "To read", display: '📖' }
            ],
            newWords: ["Courir", "Marcher", "Sauter", "Danser", "Chanter", "Dormir", "Jouer", "Lire"]
        },

        'french_m6_activity_scramble1': {
            activityType: 'sentenceScramble',
            content: [
                { hint: "I run fast", scrambled: "Je, cours, vite", correct: "Je cours vite" },
                { hint: "I walk slowly", scrambled: "Je, marche, lentement", correct: "Je marche lentement" },
                { hint: "I jump high", scrambled: "Je, saute, haut", correct: "Je saute haut" },
                { hint: "I dance well", scrambled: "Je, danse, bien", correct: "Je danse bien" },
                { hint: "I sing a song", scrambled: "Je, chante, une, chanson", correct: "Je chante une chanson" },
                { hint: "I sleep at night", scrambled: "Je, dors, la, nuit", correct: "Je dors la nuit" },
                { hint: "I play outside", scrambled: "Je, joue, dehors", correct: "Je joue dehors" },
                { hint: "I read a book", scrambled: "Je, lis, un, livre", correct: "Je lis un livre" }
            ],
            newWords: []
        },

        'french_m6_quiz3_action_words': {
            quiz: [
                { question: 'What does "Courir" mean?', options: ['To walk', 'To run', 'To jump'], answer: 'To run' },
                { question: 'How do you say "To dance"?', options: ['Danser', 'Chanter', 'Sauter'], answer: 'Danser' },
                { question: 'When you are tired, you "Dormir". What does it mean?', options: ['To sleep', 'To play', 'To read'], answer: 'To sleep' },
                { question: 'How do you say "To read"?', options: ['Écrire', 'Lire', 'Parler'], answer: 'Lire' },
                { question: 'What is "Jouer"?', options: ['To play', 'To run', 'To jump'], answer: 'To play' }
            ],
            newWords: []
        },

        'french_m6_activity_convo1': {
            activityType: 'simpleConversation',
            content: [
                { prompt: "Someone asks: Que fais-tu?", options: ['Je joue', 'Je dors', 'Je cours'], correct: ['Je joue', 'Je dors', 'Je cours'] },
                { prompt: "Someone asks: Aimes-tu danser?", options: ["Oui, j'aime danser", "Non, je n'aime pas danser", 'Je suis fatigué'], correct: ["Oui, j'aime danser", "Non, je n'aime pas danser"] },
                { prompt: "You are running. You say:", options: ['Je cours', 'Je marche', 'Je saute'], correct: 'Je cours' },
                { prompt: "You are reading a book. You say:", options: ['Je lis un livre', 'Je chante', 'Je joue'], correct: 'Je lis un livre' },
                { prompt: "Someone asks: Tu dors?", options: ['Oui, je dors', 'Non, je joue', 'Je cours'], correct: ['Oui, je dors', 'Non, je joue'] },
                { prompt: "You want to play outside. You say:", options: ['Je veux jouer dehors', 'Je veux dormir', 'Je veux manger'], correct: 'Je veux jouer dehors' },
                { prompt: "You are singing. You say:", options: ['Je chante', 'Je danse', 'Je lis'], correct: 'Je chante' },
                { prompt: "Someone asks if you can jump high:", options: ['Oui, je peux sauter haut', 'Non, je marche', 'Je dors'], correct: 'Oui, je peux sauter haut' }
            ],
            newWords: []
        },

        'french_m6_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 6 Review",
                sourceQuizzes: ['french_m6_quiz1_head_face', 'french_m6_quiz2_arms_legs', 'french_m6_quiz3_action_words']
            }
        },

        // ===== UNIT 7: NUMBERS & ADJECTIVES =====
        
        // Cultural Note: Cameroon
        'french_m7_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: Intellectual Hub',
            country: 'Cameroon',
            flagEmoji: '🇨🇲',
            content: `Cameroon has an incredibly high literacy rate and a strong academic tradition. It has produced world-renowned philosophers, writers, and scientists who contribute to global knowledge.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit7_cameroon.webp'
        },
        
        'french_m7_lesson1_numbers_beyond_ten': {
            content: [
                { word: "Onze", wordEnglish: "Eleven", display: '1️⃣1️⃣' },
                { word: "Douze", wordEnglish: "Twelve", display: '1️⃣2️⃣' },
                { word: "Vingt", wordEnglish: "Twenty", display: '2️⃣0️⃣' },
                { word: "Trente", wordEnglish: "Thirty", display: '3️⃣0️⃣' },
                { word: "Cent", wordEnglish: "One Hundred", display: '💯' }
            ],
            newWords: ["Onze", "Douze", "Vingt", "Trente", "Cent"]
        },

        'french_m7_activity_match1': {
            activityType: 'numberMatch',
            content: [
                { prompt: "11", options: ['Onze', 'Dix', 'Vingt'], correct: 'Onze' },
                { prompt: "20", options: ['Douze', 'Vingt', 'Trente'], correct: 'Vingt' },
                { prompt: "100", options: ['Trente', 'Cent', 'Dix'], correct: 'Cent' },
                { prompt: "30", options: ['Trente', 'Vingt', 'Cent'], correct: 'Trente' },
                { prompt: "Big", options: ['Grand', 'Petit', 'Rapide'], correct: 'Grand' },
                { prompt: "Small", options: ['Petit', 'Grand', 'Lent'], correct: 'Petit' },
                { prompt: "Fast", options: ['Rapide', 'Lent', 'Chaud'], correct: 'Rapide' },
                { prompt: "Hot", options: ['Chaud', 'Froid', 'Beau'], correct: 'Chaud' }
            ],
            newWords: []
        },

        'french_m7_quiz1_numbers_beyond_ten': {
            quiz: [
                { question: 'What number is "Vingt"?', options: ['Twelve', 'Fifteen', 'Twenty'], answer: 'Twenty' },
                { question: 'How do you say "Eleven"?', options: ['Onze', 'Douze', 'Dix'], answer: 'Onze' },
                { question: 'Which number is "Cent"?', options: ['Fifty', 'One Hundred', 'Thirty'], answer: 'One Hundred' },
                { question: 'How do you say "Thirty"?', options: ['Dix-neuf', 'Trente', 'Vingt'], answer: 'Trente' }
            ],
            newWords: []
        },

        'french_m7_lesson2_adjectives': {
            content: [
                { word: "Grand", wordEnglish: "Big", display: '🐘' },
                { word: "Petit", wordEnglish: "Small", display: '🐁' },
                { word: "Rapide", wordEnglish: "Fast", display: '🐆' },
                { word: "Lent", wordEnglish: "Slow", display: '🐢' },
                { word: "Fort", wordEnglish: "Strong", display: '💪🏾' },
                { word: "Chaud", wordEnglish: "Hot", display: '🔥' },
                { word: "Froid", wordEnglish: "Cold", display: '❄️' },
                { word: "Propre", wordEnglish: "Clean", display: '✨' },
                { word: "Beau", wordEnglish: "Beautiful", display: '🌺' }
            ],
            newWords: ["Grand", "Petit", "Rapide", "Lent", "Fort", "Chaud", "Froid", "Propre", "Beau"]
        },

        'french_m7_activity_whatami1': {
            activityType: 'whatAmI',
            content: [
                { clue: "Je suis grand", options: ['Elephant', 'Mouse', 'Ant', 'Dog'], correct: 'Elephant' },
                { clue: "Je suis petit", options: ['Mouse', 'Elephant', 'Lion', 'Horse'], correct: 'Mouse' },
                { clue: "Je suis rapide", options: ['Leopard', 'Tortoise', 'Cow', 'Elephant'], correct: 'Leopard' },
                { clue: "Je suis lent", options: ['Tortoise', 'Leopard', 'Horse', 'Dog'], correct: 'Tortoise' },
                { clue: "Je suis chaud", options: ['Fire', 'Ice', 'Water', 'Wind'], correct: 'Fire' },
                { clue: "Je suis froid", options: ['Ice', 'Fire', 'Sun', 'Star'], correct: 'Ice' },
                { clue: "Je suis fort", options: ['Strong person', 'Baby', 'Mouse', 'Ant'], correct: 'Strong person' },
                { clue: "Je suis beau", options: ['Flower', 'Trash', 'Mud', 'Rock'], correct: 'Flower' }
            ],
            newWords: []
        },

        'french_m7_quiz2_adjectives': {
            quiz: [
                { question: 'An elephant is "Grand". What does that mean?', options: ['Small', 'Big', 'Fast'], answer: 'Big' },
                { question: 'A tortoise is "Lent". What does "Lent" mean?', options: ['Slow', 'Fast', 'Strong'], answer: 'Slow' },
                { question: 'How do you say "Hot"?', options: ['Froid', 'Chaud', 'Fort'], answer: 'Chaud' },
                { question: 'A mouse is very "Petit". What does it mean?', options: ['Fast', 'Big', 'Small'], answer: 'Small' },
                { question: 'How do you say "Beautiful"?', options: ['Beau', 'Laid', 'Grand'], answer: 'Beau' }
            ],
            newWords: []
        },

        'french_m7_activity_convo1': {
            activityType: 'simpleConversation',
            content: [
                { prompt: "Someone asks: L'éléphant est grand ou petit?", options: ["L'éléphant est grand", "L'éléphant est petit", "L'éléphant est rapide"], correct: "L'éléphant est grand" },
                { prompt: "Someone asks: La tortue est rapide ou lente?", options: ['La tortue est lente', 'La tortue est rapide', 'La tortue est forte'], correct: 'La tortue est lente' },
                { prompt: "You see a beautiful flower. You say:", options: ['La fleur est belle', 'La fleur est laide', 'La fleur est grande'], correct: 'La fleur est belle' },
                { prompt: "It is a hot day. You say:", options: ['Il fait chaud', 'Il fait froid', 'Il pleut'], correct: 'Il fait chaud' },
                { prompt: "Someone asks: Combien font 20 + 10?", options: ['Trente', 'Vingt', 'Cent'], correct: 'Trente' },
                { prompt: "Someone asks: Tu es fort?", options: ['Oui, je suis fort', 'Non, je suis petit', 'Je suis beau'], correct: 'Oui, je suis fort' },
                { prompt: "The room is clean. You say:", options: ['La chambre est propre', 'La chambre est sale', 'La chambre est grande'], correct: 'La chambre est propre' },
                { prompt: "Someone asks the number 100:", options: ['Cent', 'Vingt', 'Trente'], correct: 'Cent' }
            ],
            newWords: []
        },

        'french_m7_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 7 Review",
                sourceQuizzes: ['french_m7_quiz1_numbers_beyond_ten', 'french_m7_quiz2_adjectives']
            }
        },

        // ===== UNIT 8: MY HOME & DAILY LIFE =====
        
        // Cultural Note: Togo
        'french_m8_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: The Nana Benz',
            country: 'Togo',
            flagEmoji: '🇹🇬',
            content: `The "Nana Benz" were Togolese women who became millionaires trading textiles! They were the first to drive Mercedes-Benz cars, becoming icons of female entrepreneurship and economic power.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit8_togo.webp'
        },
        
        'french_m8_lesson1_house_places': {
            content: [
                { word: "Maison", wordEnglish: "House", display: '🏠' },
                { word: "Chambre", wordEnglish: "Room", display: '🚪' },
                { word: "Cuisine", wordEnglish: "Kitchen", display: '🍳' },
                { word: "Salon", wordEnglish: "Living Room", display: '🛋️' },
                { word: "Chambre à coucher", wordEnglish: "Bedroom", display: '🛏️' },
                { word: "Salle de bain", wordEnglish: "Bathroom", display: '🛁' }
            ],
            newWords: ["Maison", "Chambre", "Cuisine", "Salon", "Chambre à coucher", "Salle de bain"]
        },

        'french_m8_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'Cuisine', options: ['Kitchen', 'Bathroom', 'Bedroom', 'Living Room'], correct: 'Kitchen' },
                { audio: 'Salon', options: ['Living Room', 'Kitchen', 'Bedroom', 'Bathroom'], correct: 'Living Room' },
                { audio: 'Chambre à coucher', options: ['Bedroom', 'Bathroom', 'Kitchen', 'Living Room'], correct: 'Bedroom' },
                { audio: 'Salle de bain', options: ['Bathroom', 'Bedroom', 'Kitchen', 'Living Room'], correct: 'Bathroom' },
                { audio: 'Maison', options: ['House', 'School', 'Hospital', 'Church'], correct: 'House' },
                { audio: 'Chambre', options: ['Room', 'Door', 'Window', 'Table'], correct: 'Room' },
                { audio: 'Lit', options: ['Bed', 'Chair', 'Table', 'Door'], correct: 'Bed' },
                { audio: 'Chaise', options: ['Chair', 'Bed', 'Table', 'Book'], correct: 'Chair' }
            ],
            newWords: []
        },

        'french_m8_quiz1_house_places': {
            quiz: [
                { question: 'Where do you cook food?', options: ['Salon', 'Cuisine', 'Salle de bain'], answer: 'Cuisine' },
                { question: 'How do you say "Bedroom"?', options: ['Chambre à coucher', 'Salon', 'Salle de bain'], answer: 'Chambre à coucher' },
                { question: 'Where do you take a bath?', options: ['Cuisine', 'Salle de bain', 'Salon'], answer: 'Salle de bain' },
                { question: 'What is the "Salon"?', options: ['Kitchen', 'Living Room', 'Bathroom'], answer: 'Living Room' },
                { question: 'How do you say "House"?', options: ['Chambre', 'Maison', 'Porte'], answer: 'Maison' }
            ],
            newWords: []
        },

        'french_m8_lesson2_room_things': {
            content: [
                { word: "Lit", wordEnglish: "Bed", display: '🛏️' },
                { word: "Chaise", wordEnglish: "Chair", display: '🪑' },
                { word: "Table", wordEnglish: "Table", display: '🍽️' },
                { word: "Livre", wordEnglish: "Book", display: '📖' },
                { word: "Porte", wordEnglish: "Door", display: '🚪' },
                { word: "Vêtements", wordEnglish: "Clothes", display: '👕' }
            ],
            newWords: ["Lit", "Chaise", "Table", "Livre", "Porte", "Vêtements"]
        },

        'french_m8_activity_sort1': {
            activityType: 'categorySort',
            content: {
                categories: ["In the Kitchen", "In the Bedroom"],
                items: [
                    { word: 'Table', category: 'In the Kitchen' },
                    { word: 'Lit', category: 'In the Bedroom' },
                    { word: 'Chaise', category: 'In the Kitchen' },
                    { word: 'Vêtements', category: 'In the Bedroom' },
                    { word: 'Livre', category: 'In the Bedroom' },
                    { word: 'Cuisinière', category: 'In the Kitchen' },
                    { word: 'Oreiller', category: 'In the Bedroom' },
                    { word: 'Assiette', category: 'In the Kitchen' }
                ]
            },
            newWords: []
        },

        'french_m8_quiz2_room_things': {
            quiz: [
                { question: 'Where do you sleep?', options: ['Chaise', 'Lit', 'Table'], answer: 'Lit' },
                { question: 'How do you say "Book"?', options: ['Porte', 'Livre', 'Vêtements'], answer: 'Livre' },
                { question: 'What do you sit on?', options: ['Lit', 'Chaise', 'Table'], answer: 'Chaise' },
                { question: 'You eat dinner on a:', options: ['Lit', 'Porte', 'Table'], answer: 'Table' },
                { question: 'What are "Vêtements"?', options: ['Clothes', 'Books', 'Doors'], answer: 'Clothes' }
            ],
            newWords: []
        },

        'french_m8_lesson3_daily_routines': {
            content: [
                { word: "Je me réveille", wordEnglish: "I wake up", display: '🌅' },
                { word: "Je mange", wordEnglish: "I eat", display: '😋' },
                { word: "Je vais à l'école", wordEnglish: "I go to school", display: '🏫' },
                { word: "Je rentre à la maison", wordEnglish: "I come home", display: '🏡' },
                { word: "Je joue", wordEnglish: "I play", display: '🎲' },
                { word: "Je vais dormir", wordEnglish: "I go to sleep", display: '😴' },
                { word: "Aujourd'hui", wordEnglish: "Today", display: '📅' },
                { word: "Demain", wordEnglish: "Tomorrow", display: '➡️' }
            ],
            newWords: ["Je me réveille", "Je mange", "Je vais à l'école", "Je rentre à la maison", "Je joue", "Je vais dormir", "Aujourd'hui", "Demain"]
        },

        'french_m8_activity_scramble1': {
            activityType: 'sentenceScramble',
            content: [
                { hint: "I wake up early", scrambled: "Je, me, réveille, tôt", correct: "Je me réveille tôt" },
                { hint: "I eat breakfast", scrambled: "Je, mange, le, petit-déjeuner", correct: "Je mange le petit-déjeuner" },
                { hint: "I go to school", scrambled: "Je, vais, à, l'école", correct: "Je vais à l'école" },
                { hint: "I come home", scrambled: "Je, rentre, à, la, maison", correct: "Je rentre à la maison" },
                { hint: "I play outside", scrambled: "Je, joue, dehors", correct: "Je joue dehors" },
                { hint: "I go to sleep", scrambled: "Je, vais, dormir", correct: "Je vais dormir" },
                { hint: "Today is Monday", scrambled: "Aujourd'hui, c'est, lundi", correct: "Aujourd'hui c'est lundi" },
                { hint: "Tomorrow I play", scrambled: "Demain, je, joue", correct: "Demain je joue" }
            ],
            newWords: []
        },

        'french_m8_quiz3_daily_routines': {
            quiz: [
                { question: 'What do you do first in the morning?', options: ['Je mange', 'Je me réveille', 'Je vais dormir'], answer: 'Je me réveille' },
                { question: 'How do you say "I go to school"?', options: ["Je vais à l'école", 'Je rentre à la maison', 'Je joue'], answer: "Je vais à l'école" },
                { question: 'After school, you:', options: ['Je rentre à la maison', "Je vais à l'école", 'Je me réveille'], answer: 'Je rentre à la maison' },
                { question: 'What does "Aujourd\'hui" mean?', options: ['Yesterday', 'Today', 'Tomorrow'], answer: 'Today' },
                { question: 'At night, you:', options: ['Je me réveille', 'Je vais dormir', 'Je mange'], answer: 'Je vais dormir' }
            ],
            newWords: []
        },

        'french_m8_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 8 Review",
                sourceQuizzes: ['french_m8_quiz1_house_places', 'french_m8_quiz2_room_things', 'french_m8_quiz3_daily_routines']
            }
        },

        // ===== UNIT 9: PLACES & TRANSPORTATION =====
        
        // Cultural Note: Benin
        'french_m9_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: The Amazons',
            country: 'Benin',
            flagEmoji: '🇧🇯',
            content: `The Kingdom of Dahomey (modern Benin) had the only all-female military regiment in world history—the Mino (or Amazons). They were fearless warriors, respected for their strength and skill.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit9_benin.webp'
        },
        
        'french_m9_lesson1_town_places': {
            content: [
                { word: "École", wordEnglish: "School", display: '🏫' },
                { word: "Marché", wordEnglish: "Market", display: '🛒' },
                { word: "Hôpital", wordEnglish: "Hospital", display: '🏥' },
                { word: "Église", wordEnglish: "Church", display: '⛪' },
                { word: "Magasin", wordEnglish: "Shop", display: '🏪' },
                { word: "Maison", wordEnglish: "Home", display: '🏡' },
                { word: "Bureau", wordEnglish: "Office", display: '🏢' }
            ],
            newWords: ["École", "Marché", "Hôpital", "Église", "Magasin", "Maison", "Bureau"]
        },

        'french_m9_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'École', options: ['School', 'Market', 'Hospital', 'Church'], correct: 'School' },
                { audio: 'Marché', options: ['Market', 'Shop', 'Home', 'Farm'], correct: 'Market' },
                { audio: 'Hôpital', options: ['Hospital', 'Church', 'School', 'Shop'], correct: 'Hospital' },
                { audio: 'Église', options: ['Church', 'Market', 'School', 'Hospital'], correct: 'Church' },
                { audio: 'Magasin', options: ['Shop', 'Market', 'Home', 'Church'], correct: 'Shop' },
                { audio: 'Maison', options: ['Home', 'Shop', 'Church', 'Market'], correct: 'Home' },
                { audio: 'Voiture', options: ['Car', 'Bus', 'Bicycle', 'Motorcycle'], correct: 'Car' },
                { audio: 'Bus', options: ['Bus', 'Car', 'Train', 'Bicycle'], correct: 'Bus' }
            ],
            newWords: []
        },

        'french_m9_quiz1_town_places': {
            quiz: [
                { question: 'Where do you go to buy food and other goods?', options: ['École', 'Marché', 'Ferme'], answer: 'Marché' },
                { question: 'How do you say "School"?', options: ['Hôpital', 'École', 'Église'], answer: 'École' },
                { question: 'If you are sick, you go to the:', options: ['Hôpital', 'Magasin', 'Maison'], answer: 'Hôpital' },
                { question: 'What is a "Magasin"?', options: ['Church', 'Shop', 'Home'], answer: 'Shop' },
                { question: 'How do you say "Home"?', options: ['Maison', 'Ferme', 'Marché'], answer: 'Maison' }
            ],
            newWords: []
        },

        'french_m9_lesson2_transport': {
            content: [
                { word: "Voiture", wordEnglish: "Car", display: '🚗' },
                { word: "Bus", wordEnglish: "Bus", display: '🚌' },
                { word: "Vélo", wordEnglish: "Bicycle", display: '🚲' },
                { word: "Avion", wordEnglish: "Aeroplane", display: '✈️' },
                { word: "Moto", wordEnglish: "Motorcycle", display: '🏍️' },
                { word: "Train", wordEnglish: "Train", display: '🚂' }
            ],
            newWords: ["Voiture", "Bus", "Vélo", "Avion", "Moto", "Train"]
        },

        'french_m9_activity_sort1': {
            activityType: 'categorySort',
            content: {
                categories: ["Travels on Land", "Travels in Air"],
                items: [
                    { word: 'Voiture', category: 'Travels on Land' },
                    { word: 'Avion', category: 'Travels in Air' },
                    { word: 'Bus', category: 'Travels on Land' },
                    { word: 'Train', category: 'Travels on Land' },
                    { word: 'Moto', category: 'Travels on Land' },
                    { word: 'Vélo', category: 'Travels on Land' },
                    { word: 'Bateau', category: 'Travels on Water' },
                    { word: 'Canoe', category: 'Travels on Water' }
                ]
            },
            newWords: []
        },

        'french_m9_quiz2_transport': {
            quiz: [
                { question: 'An "Avion" travels in the sky. What is it?', options: ['Boat', 'Car', 'Aeroplane'], answer: 'Aeroplane' },
                { question: 'How do you say "Bus"?', options: ['Voiture', 'Bus', 'Moto'], answer: 'Bus' },
                { question: 'A "Train" travels on a railway. What is it?', options: ['Train', 'Boat', 'Bicycle'], answer: 'Train' },
                { question: 'A "Bateau" travels on water. What is it?', options: ['Train', 'Boat', 'Bicycle'], answer: 'Boat' },
                { question: 'How do you say "Car"?', options: ['Moto', 'Train', 'Voiture'], answer: 'Voiture' }
            ],
            newWords: []
        },

        'french_m9_lesson3_travel_phrases': {
            content: [
                { word: "Je vais à...", wordEnglish: "I am going to...", display: '➡️' },
                { word: "Allons-y", wordEnglish: "Let's go", display: '🚀' },
                { word: "Viens ici", wordEnglish: "Come here", display: '👇🏾' },
                { word: "Va là-bas", wordEnglish: "Go there", display: '👉🏾' },
                { word: "Où vas-tu?", wordEnglish: "Where are you going?", display: '❓' },
                { word: "Arrête ici", wordEnglish: "Stop here", display: '🛑' }
            ],
            newWords: ["Je vais à...", "Allons-y", "Viens ici", "Va là-bas", "Où vas-tu?", "Arrête ici"]
        },

        'french_m9_quiz3_travel_phrases': {
            quiz: [
                { question: 'To tell someone you are going to school, you would say:', options: ['Je vais au marché', "Je vais à l'école", 'Je vais à la maison'], answer: "Je vais à l'école" },
                { question: 'Which phrase means "Let\'s go"?', options: ['Viens ici', 'Allons-y', 'Va là-bas'], answer: 'Allons-y' },
                { question: 'If you are at the market and want to know the price, you ask:', options: ['Où vas-tu?', 'Combien ça coûte?', 'Arrête ici'], answer: 'Combien ça coûte?' },
                { question: 'How would you ask a friend "Where are you going?"', options: ['Où vas-tu?', 'Viens ici', 'Je vais à...'], answer: 'Où vas-tu?' },
                { question: 'What does "Arrête ici" mean?', options: ['Go there', 'Come here', 'Stop here'], answer: 'Stop here' }
            ],
            newWords: []
        },

        'french_m9_activity_convo1': {
            activityType: 'simpleConversation',
            content: [
                { prompt: "Someone asks: Où vas-tu?", options: ["Je vais à l'école", 'Je vais à la maison', 'Allons-y'], correct: ["Je vais à l'école", 'Je vais à la maison'] },
                { prompt: "Someone asks: On va au marché?", options: ["Oui, allons-y", "Non, je ne veux pas", 'Viens ici'], correct: "Oui, allons-y" },
                { prompt: "You want the bus to stop. You say:", options: ['Arrête ici', 'Va là-bas', 'Viens ici'], correct: 'Arrête ici' },
                { prompt: "Someone asks: Tu veux marcher?", options: ['Oui, je veux marcher', 'Non, je ne veux pas marcher', 'Je vais à...'], correct: ['Oui, je veux marcher', 'Non, je ne veux pas marcher'] },
                { prompt: "At the market, you ask the price:", options: ['Combien ça coûte?', 'Où vas-tu?', 'Viens ici'], correct: 'Combien ça coûte?' },
                { prompt: "To call a friend over, you say:", options: ['Viens ici', 'Va là-bas', 'Arrête ici'], correct: 'Viens ici' },
                { prompt: "You are going home. You say:", options: ['Je vais à la maison', "Je vais à l'hôpital", "Je vais à l'église"], correct: 'Je vais à la maison' },
                { prompt: "To tell a friend to go to the shop, you say:", options: ['Va au magasin', 'Viens au magasin', 'Allons au magasin'], correct: 'Va au magasin' }
            ],
            newWords: []
        },

        'french_m9_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 9 Review",
                sourceQuizzes: ['french_m9_quiz1_town_places', 'french_m9_quiz2_transport', 'french_m9_quiz3_travel_phrases']
            }
        },

        // ===== UNIT 10: WEATHER & SEASONS =====
        
        // Cultural Note: Burkina Faso
        'french_m10_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: Film Capital',
            country: 'Burkina Faso',
            flagEmoji: '🇧🇫',
            content: `Despite the heat, Ouagadougou hosts FESPACO, the largest film festival in Africa! It is the "Cannes of Africa," celebrating the creativity and storytelling genius of African filmmakers.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit10_burkina_faso.webp'
        },
        
        'french_m10_lesson1_weather': {
            content: [
                { word: "Il fait soleil", wordEnglish: "It is sunny", display: '😎' },
                { word: "Il pleut", wordEnglish: "It is raining", display: '🌧️' },
                { word: "Il y a du vent", wordEnglish: "It is windy", display: '🌬️' },
                { word: "Il y a des nuages", wordEnglish: "It is cloudy", display: '🌥️' },
                { word: "Chaud", wordEnglish: "Hot", display: '🔥' },
                { word: "Froid", wordEnglish: "Cold", display: '❄️' }
            ],
            newWords: ["Il fait soleil", "Il pleut", "Il y a du vent", "Il y a des nuages", "Chaud", "Froid"]
        },

        'french_m10_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'Il fait soleil', options: ['Sun', 'Rain', 'Wind', 'Clouds'], correct: 'Sun' },
                { audio: 'Il pleut', options: ['Rain', 'Sun', 'Snow', 'Wind'], correct: 'Rain' },
                { audio: 'Il y a du vent', options: ['Wind', 'Clouds', 'Sun', 'Rain'], correct: 'Wind' },
                { audio: 'Il y a des nuages', options: ['Clouds', 'Sun', 'Rain', 'Wind'], correct: 'Clouds' },
                { audio: 'Heure', options: ['Clock', 'Sun', 'Moon', 'Stars'], correct: 'Clock' },
                { audio: 'Matin', options: ['Morning', 'Afternoon', 'Evening', 'Night'], correct: 'Morning' },
                { audio: 'Après-midi', options: ['Afternoon', 'Morning', 'Evening', 'Night'], correct: 'Afternoon' },
                { audio: 'Soir', options: ['Evening', 'Morning', 'Afternoon', 'Night'], correct: 'Evening' }
            ],
            newWords: []
        },

        'french_m10_quiz1_weather': {
            quiz: [
                { question: 'When you need an umbrella, it means:', options: ['Il fait soleil', 'Il pleut', 'Il y a du vent'], answer: 'Il pleut' },
                { question: 'How do you say "Sun"?', options: ['Soleil', 'Pluie', 'Vent'], answer: 'Soleil' },
                { question: 'On a day that is "Chaud", you might want to swim. What is the weather like?', options: ['Cold', 'Windy', 'Hot'], answer: 'Hot' },
                { question: 'What does "Nuage" mean?', options: ['Cloud', 'Sky', 'Wind'], answer: 'Cloud' },
                { question: 'How do you say "It is windy"?', options: ['Il y a du vent', 'Il y a des nuages', 'Il fait beau'], answer: 'Il y a du vent' }
            ],
            newWords: []
        },

        'french_m10_lesson2_seasons': {
            content: [
                { word: "Saison sèche", wordEnglish: "Dry Season", display: '🏜️' },
                { word: "Saison des pluies", wordEnglish: "Rainy Season", display: '🌦️' },
                { word: "Harmattan", wordEnglish: "Harmattan", display: '🌫️' },
                { word: "Matin", wordEnglish: "Morning", display: '🌅' },
                { word: "Après-midi", wordEnglish: "Afternoon", display: '☀️' },
                { word: "Soir", wordEnglish: "Evening", display: '🌇' },
                { word: "Nuit", wordEnglish: "Night", display: '🌃' }
            ],
            newWords: ["Saison sèche", "Saison des pluies", "Harmattan", "Matin", "Après-midi", "Soir", "Nuit"]
        },

        'french_m10_activity_sort1': {
            activityType: 'categorySort',
            content: {
                categories: ["Seasons", "Times of Day"],
                items: [
                    { word: 'Saison sèche', category: 'Seasons' },
                    { word: 'Matin', category: 'Times of Day' },
                    { word: 'Saison des pluies', category: 'Seasons' },
                    { word: 'Nuit', category: 'Times of Day' },
                    { word: 'Harmattan', category: 'Seasons' },
                    { word: 'Après-midi', category: 'Times of Day' },
                    { word: 'Soir', category: 'Times of Day' },
                    { word: 'Aube', category: 'Times of Day' }
                ]
            },
            newWords: []
        },

        'french_m10_quiz2_seasons': {
            quiz: [
                { question: 'The season with very little rain is called:', options: ['Saison des pluies', 'Saison sèche', 'Harmattan'], answer: 'Saison sèche' },
                { question: 'How do you say "Morning"?', options: ['Après-midi', 'Matin', 'Nuit'], answer: 'Matin' },
                { question: 'The "Saison des pluies" is the:', options: ['Rainy Season', 'Dry Season', 'Harmattan'], answer: 'Rainy Season' },
                { question: 'What does "Nuit" mean?', options: ['Afternoon', 'Evening', 'Night'], answer: 'Night' },
                { question: '"Harmattan" refers to which season?', options: ['Rainy Season', 'Dry Season', 'Harmattan'], answer: 'Harmattan' }
            ],
            newWords: []
        },

        'french_m10_activity_convo1': {
            activityType: 'simpleConversation',
            content: [
                { prompt: "Someone asks: Quel temps fait-il aujourd'hui?", options: ['Il fait soleil', 'Il pleut', 'Il fait chaud'], correct: ['Il fait soleil', 'Il pleut'] },
                { prompt: "You see clouds. You say:", options: ['Il y a des nuages', 'Il fait soleil', 'Il y a du vent'], correct: 'Il y a des nuages' },
                { prompt: "It is cold. You say:", options: ["J'ai froid", "J'ai chaud", "J'ai faim"], correct: "J'ai froid" },
                { prompt: "It is windy. You say:", options: ['Il y a du vent', 'Il pleut', 'Il fait soleil'], correct: 'Il y a du vent' },
                { prompt: "Someone asks: C'est le matin ou l'après-midi?", options: ["C'est le matin", "C'est l'après-midi", "C'est la nuit"], correct: ["C'est le matin", "C'est l'après-midi"] },
                { prompt: "You need an umbrella because:", options: ['Il pleut', 'Il fait soleil', 'Il y a du vent'], correct: 'Il pleut' },
                { prompt: "It is hot today. You say:", options: ['Il fait chaud', 'Il fait froid', 'Il pleut'], correct: 'Il fait chaud' },
                { prompt: "At night, you say:", options: ["C'est la nuit", "C'est le matin", "C'est l'après-midi"], correct: "C'est la nuit" }
            ],
            newWords: []
        },

        'french_m10_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 10 Review",
                sourceQuizzes: ['french_m10_quiz1_weather', 'french_m10_quiz2_seasons']
            }
        },

        // ===== UNIT 11: FEELINGS & EXPRESSIONS =====
        
        // Cultural Note: Gabon
        'french_m11_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: Conservation Leaders',
            country: 'Gabon',
            flagEmoji: '🇬🇦',
            content: `Gabon has set aside over 10% of its land for national parks! It is a global leader in conservation, proving that a nation can protect its natural beauty for future generations.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit11_gabon.webp'
        },
        
        'french_m11_lesson1_feelings': {
            content: [
                { word: "Heureux", wordEnglish: "Happy", display: '😊' },
                { word: "Triste", wordEnglish: "Sad", display: '😢' },
                { word: "En colère", wordEnglish: "Angry", display: '😠' },
                { word: "Fatigué", wordEnglish: "Tired", display: '😫' },
                { word: "Faim", wordEnglish: "Hunger", display: '🍽️' },
                { word: "Peur", wordEnglish: "Scared / Fear", display: '😨' },
                { word: "Effrayé", wordEnglish: "Afraid", display: '😰' },
                { word: "Calme", wordEnglish: "Calm", display: '😌' }
            ],
            newWords: ["Heureux", "Triste", "En colère", "Fatigué", "Faim", "Peur", "Effrayé", "Calme"]
        },

        'french_m11_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'Heureux', options: ['Happy', 'Sad', 'Angry', 'Tired'], correct: 'Happy' },
                { audio: 'Triste', options: ['Sad', 'Happy', 'Scared', 'Angry'], correct: 'Sad' },
                { audio: 'En colère', options: ['Angry', 'Happy', 'Sad', 'Tired'], correct: 'Angry' },
                { audio: 'Fatigué', options: ['Tired', 'Hungry', 'Happy', 'Sad'], correct: 'Tired' },
                { audio: 'Peur', options: ['Scared', 'Happy', 'Sad', 'Angry'], correct: 'Scared' },
                { audio: 'Je suis très heureux', options: ['Happy', 'Sad', 'Angry', 'Tired'], correct: 'Happy' },
                { audio: "J'ai peur", options: ['Afraid', 'Happy', 'Angry', 'Calm'], correct: 'Afraid' },
                { audio: 'Je suis très en colère', options: ['Angry', 'Happy', 'Sad', 'Scared'], correct: 'Angry' }
            ],
            newWords: []
        },

        'french_m11_quiz1_feelings': {
            quiz: [
                { question: 'If you receive a gift, you might feel "Heureux". What is this feeling?', options: ['Sad', 'Angry', 'Happy'], answer: 'Happy' },
                { question: 'How do you say "I am tired"?', options: ["J'ai faim", 'Je suis heureux', 'Je suis fatigué'], answer: 'Je suis fatigué' },
                { question: 'What does "En colère" mean?', options: ['Scared', 'Angry', 'Surprised'], answer: 'Angry' },
                { question: 'If your tummy is rumbling, you have "Faim", which is:', options: ['Thirst', 'Hunger', 'Sadness'], answer: 'Hunger' },
                { question: 'A scary movie might make you feel "Peur". What is "Peur"?', options: ['Surprised', 'Scared', 'Tired'], answer: 'Scared' }
            ],
            newWords: []
        },

        'french_m11_lesson2_opinions': {
            content: [
                { word: "J'aime", wordEnglish: "I like", display: '👍🏾' },
                { word: "Je n'aime pas", wordEnglish: "I don't like", display: '👎🏾' },
                { word: "C'est délicieux", wordEnglish: "It is delicious", display: '😋' },
                { word: "C'est beau", wordEnglish: "It is beautiful", display: '😍' },
                { word: "C'est mauvais", wordEnglish: "It is bad", display: '😠' }
            ],
            newWords: ["J'aime", "Je n'aime pas", "C'est délicieux", "C'est beau", "C'est mauvais"]
        },

        'french_m11_activity_scramble1': {
            activityType: 'sentenceScramble',
            content: [
                { hint: "I like oranges", scrambled: "J'aime, les, oranges", correct: "J'aime les oranges" },
                { hint: "I don't like snakes", scrambled: "Je, n'aime, pas, les, serpents", correct: "Je n'aime pas les serpents" },
                { hint: "The food is delicious", scrambled: "La, nourriture, est, délicieuse", correct: "La nourriture est délicieuse" },
                { hint: "The flower is beautiful", scrambled: "La, fleur, est, belle", correct: "La fleur est belle" },
                { hint: "The elephant is big", scrambled: "L'éléphant, est, grand", correct: "L'éléphant est grand" },
                { hint: "The cat is small", scrambled: "Le, chat, est, petit", correct: "Le chat est petit" },
                { hint: "The soup is good", scrambled: "La, soupe, est, bonne", correct: "La soupe est bonne" },
                { hint: "This is bad", scrambled: "C'est, mauvais", correct: "C'est mauvais" }
            ],
            newWords: []
        },

        'french_m11_quiz2_opinions': {
            quiz: [
                { question: 'To say you like something, you use the phrase:', options: ["J'aime", "C'est délicieux", "Je n'aime pas"], answer: "J'aime" },
                { question: 'How do you say "I don\'t like"?', options: ["J'aime", "C'est mauvais", "Je n'aime pas"], answer: "Je n'aime pas" },
                { question: 'A delicious meal can be described as:', options: ["C'est délicieux", "C'est mauvais", "C'est beau"], answer: "C'est délicieux" },
                { question: 'How do you say "It is beautiful"?', options: ["C'est délicieux", "C'est beau", "J'aime"], answer: "C'est beau" },
                { question: 'The opposite of "J\'aime" is:', options: ["Je n'aime pas", 'Je suis', 'Je veux'], answer: "Je n'aime pas" }
            ],
            newWords: []
        },

        'french_m11_activity_convo1': {
            activityType: 'simpleConversation',
            content: [
                { prompt: "Someone shows picture of a dog, asks: Aimes-tu les chiens?", options: ["Oui, j'aime", "Non, je n'aime pas", 'Je m\'appelle...'], correct: ["Oui, j'aime", "Non, je n'aime pas"] },
                { prompt: "Someone shows picture of a beautiful flower, asks: La fleur est belle?", options: ["Oui, elle est belle", "Non, elle n'est pas belle", 'Je vais bien'], correct: "Oui, elle est belle" },
                { prompt: "I am happy. You say:", options: ['Je suis heureux', 'Je suis triste', 'Je suis fatigué'], correct: 'Je suis heureux' },
                { prompt: "You are sad. You say:", options: ['Je suis triste', 'Je suis heureux', "J'ai faim"], correct: 'Je suis triste' },
                { prompt: "You are tired. You say:", options: ['Je suis fatigué', "J'ai soif", 'Merci'], correct: 'Je suis fatigué' },
                { prompt: "Someone asks if you like snakes: Aimes-tu les serpents?", options: ["Non, je n'aime pas", "Oui, j'aime", 'Je t\'aime'], correct: ["Non, je n'aime pas", "Oui, j'aime"] },
                { prompt: "Someone asks if the soup is delicious: La soupe est délicieuse?", options: ["Oui, c'est délicieux", "Non, ce n'est pas bon", "J'ai soif"], correct: "Oui, c'est délicieux" },
                { prompt: "You are angry. You say:", options: ['Je suis en colère', 'Je suis heureux', 'Je suis rassasié'], correct: 'Je suis en colère' }
            ],
            newWords: []
        },

        'french_m11_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 11 Review",
                sourceQuizzes: ['french_m11_quiz1_feelings', 'french_m11_quiz2_opinions']
            }
        },

        // ===== UNIT 12: PUTTING IT ALL TOGETHER =====
        
        // Cultural Note: Pan-African
        'french_m12_cultural_note': {
            type: 'culturalNote',
            title: 'Cultural Note: The Future is Young',
            country: 'Pan-African',
            flagEmoji: '🌍',
            content: `Africa is the youngest continent on Earth! Francophone Africa is bursting with the energy, creativity, and innovation of a new generation that is reshaping the world's future.`,
            illustrationUrl: 'https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/french/cultural_notes/optimized/french_unit12_pan_africa.webp'
        },
        
        'french_m12_lesson1_questions': {
            content: [
                { word: "Qui?", wordEnglish: "Who?", display: '👤' },
                { word: "Quoi?", wordEnglish: "What?", display: '❓' },
                { word: "Où?", wordEnglish: "Where?", display: '📍' },
                { word: "Quand?", wordEnglish: "When?", display: '📅' },
                { word: "Pourquoi?", wordEnglish: "Why?", display: '💡' },
                { word: "Comment?", wordEnglish: "How?", display: '🤷🏾' }
            ],
            newWords: ["Qui?", "Quoi?", "Où?", "Quand?", "Pourquoi?", "Comment?"]
        },

        'french_m12_activity_listen1': {
            activityType: 'listenFind',
            content: [
                { audio: 'Qui?', options: ['Who?', 'What?', 'Where?', 'When?'], correct: 'Who?' },
                { audio: 'Quoi?', options: ['What?', 'Why?', 'How?', 'Who?'], correct: 'What?' },
                { audio: 'Où?', options: ['Where?', 'When?', 'Who?', 'Why?'], correct: 'Where?' },
                { audio: 'Pourquoi?', options: ['Why?', 'How?', 'What?', 'Where?'], correct: 'Why?' },
                { audio: 'Comment?', options: ['How?', 'What?', 'Why?', 'When?'], correct: 'How?' },
                { audio: 'Quand?', options: ['When?', 'Where?', 'Who?', 'How?'], correct: 'When?' },
                { audio: 'Oui', options: ['Yes', 'No', 'Please', 'Thank you'], correct: 'Yes' },
                { audio: 'Non', options: ['No', 'Yes', 'Maybe', 'I don\'t know'], correct: 'No' }
            ],
            newWords: []
        },

        'french_m12_quiz1_questions': {
            quiz: [
                { question: 'If you want to know a person\'s name, you ask "Quel est ton nom?". Which question word is used?', options: ['Quoi?', 'Qui?', 'Où?'], answer: 'Qui?' },
                { question: 'To ask for the location of something, you use:', options: ['Où?', 'Quand?', 'Pourquoi?'], answer: 'Où?' },
                { question: 'How do you say "Why"?', options: ['Comment?', 'Quoi?', 'Pourquoi?'], answer: 'Pourquoi?' },
                { question: 'To ask "When?", you would say:', options: ['Quelle heure?', 'Quand?', 'Comment?'], answer: 'Quand?' },
                { question: 'Which word means "How?"', options: ['Quoi?', 'Comment?', 'Pourquoi?'], answer: 'Comment?' }
            ],
            newWords: []
        },

        'french_m12_lesson2_connectors': {
            content: [
                { word: "Et", wordEnglish: "And", display: '🔗' },
                { word: "Mais", wordEnglish: "But", display: '⚖️' },
                { word: "Parce que", wordEnglish: "Because", display: '💡' },
                { word: "Ou", wordEnglish: "Or", display: '🤷🏾‍♀️' },
                { word: "Donc", wordEnglish: "So / Therefore", display: '➡️' }
            ],
            newWords: ["Et", "Mais", "Parce que", "Ou", "Donc"]
        },

        'french_m12_activity_scramble1': {
            activityType: 'sentenceScramble',
            content: [
                { hint: "I like rice and soup", scrambled: "J'aime, le, riz, et, la, soupe", correct: "J'aime le riz et la soupe" },
                { hint: "I am going, but you are staying", scrambled: "Je, pars, mais, tu, restes", correct: "Je pars mais tu restes" },
                { hint: "I am happy because you are here", scrambled: "Je, suis, heureux, parce, que, tu, es, ici", correct: "Je suis heureux parce que tu es ici" },
                { hint: "I understand", scrambled: "Je, comprends", correct: "Je comprends" },
                { hint: "Can you help me?", scrambled: "Peux-tu, m'aider?", correct: "Peux-tu m'aider?" },
                { hint: "I don't know", scrambled: "Je, ne, sais, pas", correct: "Je ne sais pas" },
                { hint: "I want to learn French", scrambled: "Je, veux, apprendre, le, français", correct: "Je veux apprendre le français" },
                { hint: "What is your name?", scrambled: "Quel, est, ton, nom?", correct: "Quel est ton nom?" }
            ],
            newWords: []
        },

        'french_m12_quiz2_connectors': {
            quiz: [
                { question: 'To connect two things, you use "Et". What does it mean?', options: ['And', 'But', 'Or'], answer: 'And' },
                { question: 'How do you say "Because"?', options: ['Parce que', 'Mais', 'Ou'], answer: 'Parce que' },
                { question: 'The word "Mais" is used to show contrast. What does it mean?', options: ['But', 'And', 'Or'], answer: 'But' },
                { question: 'How do you say "Or"?', options: ['Et', 'Ou', 'Donc'], answer: 'Ou' },
                { question: 'What does "Donc" mean?', options: ['Because', 'But', 'So / Therefore'], answer: 'So / Therefore' }
            ],
            newWords: []
        },

        'french_m12_lesson3_phrases': {
            content: [
                { word: "Je comprends", wordEnglish: "I understand", display: '✅' },
                { word: "Je ne comprends pas", wordEnglish: "I don't understand", display: '❌' },
                { word: "Peux-tu m'aider?", wordEnglish: "Can you help me?", display: '🙋🏾‍♀️' },
                { word: "J'apprends le français", wordEnglish: "I am learning French", display: '🎓' },
                { word: "Parle lentement", wordEnglish: "Speak slowly", display: '🐢' }
            ],
            newWords: ["Je comprends", "Je ne comprends pas", "Peux-tu m'aider?", "J'apprends le français", "Parle lentement"]
        },

        'french_m12_activity_sort1': {
            activityType: 'categorySort',
            content: {
                categories: ["Questions", "Feelings", "Actions"],
                items: [
                    { word: 'Qui?', category: 'Questions' },
                    { word: 'Heureux', category: 'Feelings' },
                    { word: 'Courir', category: 'Actions' },
                    { word: 'Où?', category: 'Questions' },
                    { word: 'Triste', category: 'Feelings' },
                    { word: 'Manger', category: 'Actions' },
                    { word: 'Pourquoi?', category: 'Questions' },
                    { word: 'En colère', category: 'Feelings' }
                ]
            },
            newWords: []
        },

        'french_m12_quiz3_phrases': {
            quiz: [
                { question: 'When you understand something, you say:', options: ['Je comprends', 'Je ne comprends pas', 'Parle lentement'], answer: 'Je comprends' },
                { question: 'How do you ask for help?', options: ["Peux-tu m'aider?", 'Je comprends', "J'apprends le français"], answer: "Peux-tu m'aider?" },
                { question: 'If someone is speaking too fast, you can say:', options: ['Parle lentement', 'Je comprends', "J'apprends"], answer: 'Parle lentement' },
                { question: 'What does "Je ne comprends pas" mean?', options: ['I understand', 'I don\'t understand', 'I am learning'], answer: 'I don\'t understand' },
                { question: 'To tell someone you are learning French, you say:', options: ["J'apprends le français", 'Je comprends', 'Parle vite'], answer: "J'apprends le français" }
            ],
            newWords: []
        },

        'french_m12_activity_convo1': {
            activityType: 'simpleConversation',
            content: [
                { prompt: "Someone asks: Tu comprends?", options: ['Oui, je comprends', 'Non, je ne comprends pas', 'Parle lentement'], correct: ['Oui, je comprends', 'Non, je ne comprends pas'] },
                { prompt: "Someone speaks too fast. You say:", options: ['Parle lentement', 'Je ne comprends pas', 'Répète'], correct: ['Parle lentement', 'Je ne comprends pas'] },
                { prompt: "Someone asks what you are learning:", options: ["J'apprends le français", "J'apprends le twi", "J'apprends le yoruba"], correct: "J'apprends le français" },
                { prompt: "You need help. You ask:", options: ["Peux-tu m'aider?", 'Je comprends', 'Merci'], correct: "Peux-tu m'aider?" },
                { prompt: "Someone helps you. You say:", options: ['Merci', 'De rien', 'Pardon'], correct: 'Merci' },
                { prompt: "Someone asks: Qui est-ce?", options: ["C'est mon ami", "C'est ma maison", "C'est demain"], correct: "C'est mon ami" },
                { prompt: "Someone asks: Où vas-tu?", options: ["Je vais à l'école", 'Je suis heureux', 'Je comprends'], correct: "Je vais à l'école" },
                { prompt: "You want to say goodbye. You say:", options: ['Au revoir', 'Bonjour', 'Bonsoir'], correct: 'Au revoir' }
            ],
            newWords: []
        },

        'french_m12_review': {
            type: 'chapterReview',
            content: {
                title: "Chapter 12 Review",
                sourceQuizzes: ['french_m12_quiz1_questions', 'french_m12_quiz2_connectors', 'french_m12_quiz3_phrases']
            }
        }
    },
    learningPath: [
        {
            unit: 1, 
            theme: "Greetings & Self-Introduction",
            culturalNote: "FRANCOPHONE AFRICA TOUR • STOP 1: SENEGAL. In Senegal, greetings are not just a quick hello—they show deep respect and hospitality, known as Teranga.",
            lessons: [
                { id: 'french_m1_lesson1_greetings', title: 'Lesson: Everyday Greetings', type: 'lesson', icon: '👋🏾' },
                { id: 'french_m1_quiz1_greetings', title: 'Quick Quiz: Greetings', type: 'quiz', icon: '🥇' },
                { id: 'french_m1_cultural_note', title: 'Cultural Insight: Teranga', type: 'culturalNote', icon: '🇸🇳' },
                { id: 'french_m1_lesson2_conversation', title: 'Lesson: Simple Conversation & Manners', type: 'lesson', icon: '🙂' },
                { id: 'french_m1_activity_convo1', title: 'Activity: Greeting Exchange', type: 'activity', icon: '💬' },
                { id: 'french_m1_quiz2_conversation', title: 'Quick Quiz: Manners', type: 'quiz', icon: '🥇' },
                { id: 'french_m1_lesson3_introduction', title: 'Lesson: Getting to Know You', type: 'lesson', icon: '🫆' },
                { id: 'french_m1_activity_listen1', title: 'Activity: Listen & Find', type: 'activity', icon: '🎧' },
                { id: 'french_m1_quiz3_introduction', title: 'Quick Quiz: Introductions', type: 'quiz', icon: '🥇' },
                { id: 'french_m1_story_ananse', title: 'Story Time: Ananse and the Pot of Wisdom', type: 'story', icon: '🕷️', storyId: 'ananse_and_the_pot_of_wisdom_french' },
                { id: 'french_m1_review', title: 'Chapter 1 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        // Unit 2: Family & Community
        {
            unit: 2,
            theme: "Family & Community",
            culturalNote: "FRANCOPHONE AFRICA TOUR • STOP 2: MALI. In Mali and across the Sahel, 'family' extends far beyond parents—sharing meals and raising children together.",
            lessons: [
                { id: 'french_m2_lesson1_core_family', title: 'Lesson: My Core Family', type: 'lesson', icon: '👨🏾‍👩🏾‍👧🏾‍👦🏾' },
                { id: 'french_m2_activity_sort1', title: 'Activity: Family Sort', type: 'activity', icon: '🗂️' },
                { id: 'french_m2_cultural_note', title: 'Cultural Insight: The Golden Empire', type: 'culturalNote', icon: '🇲🇱' },
                { id: 'french_m2_quiz1_core_family', title: 'Quick Quiz: Core Family', type: 'quiz', icon: '🥇' },
                { id: 'french_m2_lesson2_extended_family', title: 'Lesson: My Extended Family', type: 'lesson', icon: '👵🏾' },
                { id: 'french_m2_quiz2_extended_family', title: 'Quick Quiz: Extended Family', type: 'quiz', icon: '🥇' },
                { id: 'french_m2_lesson3_community', title: 'Lesson: People in My Community', type: 'lesson', icon: '🧑🏾‍🤝‍🧑🏾' },
                { id: 'french_m2_activity_listen1', title: 'Activity: Listen & Find', type: 'activity', icon: '🎧' },
                { id: 'french_m2_quiz3_community', title: 'Quick Quiz: Community', type: 'quiz', icon: '🥇' },
                { id: 'french_m2_activity_convo1', title: 'Simple Conversation: Introducing Family', type: 'activity', icon: '💬' },
                { id: 'french_m2_review', title: 'Chapter 2 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        // Unit 3: Colors & Numbers
        {
            unit: 3,
            theme: "Colors & Numbers",
            culturalNote: "FRANCOPHONE AFRICA TOUR • REGIONAL INSIGHT. Counting is daily skill! In many West African markets, bargaining is expected—know your numbers in French!",
            lessons: [
                { id: 'french_m3_lesson1_numbers1_10', title: 'Lesson: Counting from 1 to 10', type: 'lesson', icon: '🔢' },
                { id: 'french_m3_activity_match1', title: 'Activity: Number Match', type: 'activity', icon: '🧮' },
                { id: 'french_m3_cultural_note', title: 'Cultural Insight: Mobile Money', type: 'culturalNote', icon: '🌍' },
                { id: 'french_m3_quiz1_numbers1_10', title: 'Quick Quiz: Numbers 1-10', type: 'quiz', icon: '🥇' },
                { id: 'french_m3_lesson2_colors', title: 'Lesson: Learning My Colors', type: 'lesson', icon: '🎨' },
                { id: 'french_m3_colormatch', title: 'Activity: Color Match', type: 'activity', icon: '🖌️' },
                { id: 'french_m3_quiz2_colors', title: 'Quick Quiz: Colors', type: 'quiz', icon: '🥇' },
                { id: 'french_m3_lesson3_more_numbers_colors', title: 'Lesson: Bigger Numbers & More Colors', type: 'lesson', icon: '➕' },
                { id: 'french_m3_activity_listen1', title: 'Activity: Listen & Find (Colors & Numbers)', type: 'activity', icon: '🎧' },
                { id: 'french_m3_quiz3_more_numbers_colors', title: 'Quick Quiz: More Numbers & Colors', type: 'quiz', icon: '🥇' },
                { id: 'french_m3_review', title: 'Chapter 3 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        {
            unit: 4,
            theme: "Animals & Nature",
            culturalNote: "FRANCOPHONE AFRICA TOUR • STOP 4: DR CONGO. The Congo Basin is the second-largest rainforest—home to Bonobos and Okapis found nowhere else!",
            lessons: [
                { id: 'french_m4_lesson1_farm_animals', title: 'Lesson: Farm & Domestic Animals', type: 'lesson', icon: '🐔' },
                { id: 'french_m4_activity_listen1', title: 'Activity: Listen & Find (Farm Animals)', type: 'activity', icon: '🎧' },
                { id: 'french_m4_cultural_note', title: 'Cultural Insight: Ecological Superpower', type: 'culturalNote', icon: '🇨🇩' },
                { id: 'french_m4_quiz1_farm_animals', title: 'Quick Quiz: Farm Animals', type: 'quiz', icon: '🥇' },
                { id: 'french_m4_lesson2_wild_animals', title: 'Lesson: Wild Animals', type: 'lesson', icon: '🦁' },
                { id: 'french_m4_activity_sort1', title: 'Activity: Category Sort (Animals)', type: 'activity', icon: '🗂️' },
                { id: 'french_m4_quiz2_wild_animals', title: 'Quick Quiz: Wild Animals', type: 'quiz', icon: '🥇' },
                { id: 'french_m4_lesson3_nature', title: 'Lesson: In the Natural World', type: 'lesson', icon: '🌳' },
                { id: 'french_m4_quiz3_nature', title: 'Quick Quiz: Nature Words', type: 'quiz', icon: '🥇' },
                { id: 'french_m4_review', title: 'Chapter 4 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        {
            unit: 5,
            theme: "Food & Drink",
            culturalNote: "FRANCOPHONE AFRICA TOUR • STOP 5: CÔTE D'IVOIRE. In Côte d'Ivoire, food is life! Try Attiéké at a Maquis—a lively open-air restaurant with great music.",
            lessons: [
                { id: 'french_m5_lesson1_staple_foods', title: 'Lesson: Staple Foods', type: 'lesson', icon: '🍚' },
                { id: 'french_m5_quiz1_staple_foods', title: 'Quick Quiz: Staple Foods', type: 'quiz', icon: '🥇' },
                { id: 'french_m5_cultural_note', title: 'Cultural Insight: The Cocoa Giant', type: 'culturalNote', icon: '🇨🇮' },
                { id: 'french_m5_lesson2_fruits_vegetables', title: 'Lesson: Fruits & Vegetables', type: 'lesson', icon: '🍎' },
                { id: 'french_m5_activity_sort1', title: 'Activity: Category Sort (Food)', type: 'activity', icon: '🗂️' },
                { id: 'french_m5_quiz2_fruits_vegetables', title: 'Quick Quiz: Fruits & Vegetables', type: 'quiz', icon: '🥇' },
                { id: 'french_m5_lesson3_eating_phrases', title: 'Lesson: Time to Eat! (Phrases)', type: 'lesson', icon: '🍽️' },
                { id: 'french_m5_activity_listen1', title: 'Activity: Listen & Find (All Foods)', type: 'activity', icon: '🎧' },
                { id: 'french_m5_quiz3_eating_phrases', title: 'Quick Quiz: Eating Phrases', type: 'quiz', icon: '🥇' },
                { id: 'french_m5_activity_convo1', title: 'Simple Conversation: At the Table', type: 'activity', icon: '💬' },
                { id: 'french_m5_review', title: 'Chapter 5 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        {
            unit: 6,
            theme: "My Body & Actions",
            culturalNote: "FRANCOPHONE AFRICA TOUR • REGIONAL INSIGHT. Body language speaks loudly! Using your right hand to greet, eat, or give gifts shows respect across Africa.",
            lessons: [
                { id: 'french_m6_lesson1_head_face', title: 'Lesson: My Head & Face', type: 'lesson', icon: '👦🏾' },
                { id: 'french_m6_activity_listen1', title: 'Activity: Listen & Find (Head & Face)', type: 'activity', icon: '🎧' },
                { id: 'french_m6_cultural_note', title: 'Cultural Insight: Afro-Dance', type: 'culturalNote', icon: '🌍' },
                { id: 'french_m6_quiz1_head_face', title: 'Quick Quiz: Head & Face', type: 'quiz', icon: '🥇' },
                { id: 'french_m6_lesson2_arms_legs', title: 'Lesson: My Arms & Legs', type: 'lesson', icon: '💪🏾' },
                { id: 'french_m6_quiz2_arms_legs', title: 'Quick Quiz: Arms & Legs', type: 'quiz', icon: '🥇' },
                { id: 'french_m6_lesson3_action_words', title: 'Lesson: Let\'s Move! (Action Words)', type: 'lesson', icon: '🏃🏾‍♀️' },
                { id: 'french_m6_activity_scramble1', title: 'Activity: Sentence Scramble (Action Phrases)', type: 'activity', icon: '📝' },
                { id: 'french_m6_quiz3_action_words', title: 'Quick Quiz: Action Words', type: 'quiz', icon: '🥇' },
                { id: 'french_m6_activity_convo1', title: 'Simple Conversation: Giving Instructions', type: 'activity', icon: '💬' },
                { id: 'french_m6_review', title: 'Chapter 6 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        {
            unit: 7,
            theme: "Numbers & Adjectives",
            culturalNote: "FRANCOPHONE AFRICA TOUR • STOP 7: CAMEROON. Cameroon is 'Africa in Miniature'—beaches, deserts, mountains, rainforests, and savannahs all in one country!",
            lessons: [
                { id: 'french_m7_lesson1_numbers_beyond_ten', title: 'Lesson: Numbers Beyond Ten', type: 'lesson', icon: '💯' },
                { id: 'french_m7_activity_match1', title: 'Activity: Number Match', type: 'activity', icon: '🧮' },
                { id: 'french_m7_cultural_note', title: 'Cultural Insight: Intellectual Hub', type: 'culturalNote', icon: '🇨🇲' },
                { id: 'french_m7_quiz1_numbers_beyond_ten', title: 'Quick Quiz: Bigger Numbers', type: 'quiz', icon: '🥇' },
                { id: 'french_m7_lesson2_adjectives', title: 'Lesson: Describing Words (Adjectives)', type: 'lesson', icon: '✨' },
                { id: 'french_m7_activity_whatami1', title: 'Activity: What Am I?', type: 'activity', icon: '🤔' },
                { id: 'french_m7_quiz2_adjectives', title: 'Quick Quiz: Adjectives', type: 'quiz', icon: '🥇' },
                { id: 'french_m7_activity_convo1', title: 'Simple Conversation: Describing Things', type: 'activity', icon: '💬' },
                { id: 'french_m7_review', title: 'Chapter 7 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        {
            unit: 8,
            theme: "My Home & Daily Life",
            culturalNote: "FRANCOPHONE AFRICA TOUR • STOP 8: TOGO. In Togo, traditional Tata Somba homes look like castles! The home is always a place of welcome.",
            lessons: [
                { id: 'french_m8_lesson1_house_places', title: 'Lesson: Places in the House', type: 'lesson', icon: '🏠' },
                { id: 'french_m8_activity_listen1', title: 'Activity: Listen & Find (House)', type: 'activity', icon: '🎧' },
                { id: 'french_m8_cultural_note', title: 'Cultural Insight: The Nana Benz', type: 'culturalNote', icon: '🇹🇬' },
                { id: 'french_m8_quiz1_house_places', title: 'Quick Quiz: Places in the House', type: 'quiz', icon: '🥇' },
                { id: 'french_m8_lesson2_room_things', title: 'Lesson: Things in My Room', type: 'lesson', icon: '🛏️' },
                { id: 'french_m8_activity_sort1', title: 'Activity: Category Sort (Rooms)', type: 'activity', icon: '🗂️' },
                { id: 'french_m8_quiz2_room_things', title: 'Quick Quiz: Things in My Room', type: 'quiz', icon: '🥇' },
                { id: 'french_m8_lesson3_daily_routines', title: 'Lesson: My Day (Routines)', type: 'lesson', icon: '🌅' },
                { id: 'french_m8_activity_scramble1', title: 'Activity: Sentence Scramble (Routines)', type: 'activity', icon: '📝' },
                { id: 'french_m8_quiz3_daily_routines', title: 'Quick Quiz: Daily Routines', type: 'quiz', icon: '🥇' },
                { id: 'french_m8_review', title: 'Chapter 8 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        {
            unit: 9,
            theme: "Places & Transportation",
            culturalNote: "FRANCOPHONE AFRICA TOUR • STOP 9: BENIN. Benin's 'Door of No Return' in Ouidah is a powerful memorial for ancestors and the global diaspora.",
            lessons: [
                { id: 'french_m9_lesson1_town_places', title: 'Lesson: Around the Town', type: 'lesson', icon: '🏙️' },
                { id: 'french_m9_activity_listen1', title: 'Activity: Listen & Find (Places)', type: 'activity', icon: '🎧' },
                { id: 'french_m9_cultural_note', title: 'Cultural Insight: The Amazons', type: 'culturalNote', icon: '🇧🇯' },
                { id: 'french_m9_quiz1_town_places', title: 'Quick Quiz: Town Places', type: 'quiz', icon: '🥇' },
                { id: 'french_m9_lesson2_transport', title: 'Lesson: Getting Around (Transportation)', type: 'lesson', icon: '🚌' },
                { id: 'french_m9_activity_sort1', title: 'Activity: Category Sort (Transport)', type: 'activity', icon: '🗂️' },
                { id: 'french_m9_quiz2_transport', title: 'Quick Quiz: Transportation', type: 'quiz', icon: '🥇' },
                { id: 'french_m9_lesson3_travel_phrases', title: 'Lesson: Going Places (Phrases)', type: 'lesson', icon: '🗺️' },
                { id: 'french_m9_quiz3_travel_phrases', title: 'Quick Quiz: Travel Phrases', type: 'quiz', icon: '🥇' },
                { id: 'french_m9_activity_convo1', title: 'Simple Conversation: Getting Around Town', type: 'activity', icon: '💬' },
                { id: 'french_m9_review', title: 'Chapter 9 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        {
            unit: 10,
            theme: "Weather & Seasons",
            culturalNote: "FRANCOPHONE AFRICA TOUR • STOP 10: BURKINA FASO. In the Sahel like Burkina Faso, two seasons: dry (with dusty Harmattan) and rainy (l'hivernage).",
            lessons: [
                { id: 'french_m10_lesson1_weather', title: 'Lesson: Describing the Weather', type: 'lesson', icon: '🌤️' },
                { id: 'french_m10_activity_listen1', title: 'Activity: Listen & Find (Weather)', type: 'activity', icon: '🎧' },
                { id: 'french_m10_cultural_note', title: 'Cultural Insight: Film Capital', type: 'culturalNote', icon: '🇧🇫' },
                { id: 'french_m10_quiz1_weather', title: 'Quick Quiz: Weather Words', type: 'quiz', icon: '🥇' },
                { id: 'french_m10_lesson2_seasons', title: 'Lesson: Times & Seasons', type: 'lesson', icon: '🍂' },
                { id: 'french_m10_activity_sort1', title: 'Activity: Category Sort (Time & Seasons)', type: 'activity', icon: '🗂️' },
                { id: 'french_m10_quiz2_seasons', title: 'Quick Quiz: Seasons & Time', type: 'quiz', icon: '🥇' },
                { id: 'french_m10_activity_convo1', title: 'Simple Conversation: Talking About Weather', type: 'activity', icon: '💬' },
                { id: 'french_m10_review', title: 'Chapter 10 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        {
            unit: 11,
            theme: "Feelings & Expressions",
            culturalNote: "FRANCOPHONE AFRICA TOUR • STOP 11: GABON. Gabon's vibrant celebrations: expressing joy through music, dance, and festivals—happiness is shared!",
            lessons: [
                { id: 'french_m11_lesson1_feelings', title: 'Lesson: How Are You Feeling?', type: 'lesson', icon: '😊' },
                { id: 'french_m11_activity_listen1', title: 'Activity: Listen & Find (Feelings)', type: 'activity', icon: '🎧' },
                { id: 'french_m11_cultural_note', title: 'Cultural Insight: Conservation Leaders', type: 'culturalNote', icon: '🇬🇦' },
                { id: 'french_m11_quiz1_feelings', title: 'Quick Quiz: Feelings', type: 'quiz', icon: '🥇' },
                { id: 'french_m11_lesson2_opinions', title: 'Lesson: Giving Your Opinion', type: 'lesson', icon: '💭' },
                { id: 'french_m11_activity_scramble1', title: 'Activity: Sentence Scramble (Opinions)', type: 'activity', icon: '📝' },
                { id: 'french_m11_quiz2_opinions', title: 'Quick Quiz: Opinions', type: 'quiz', icon: '🥇' },
                { id: 'french_m11_activity_convo1', title: 'Simple Conversation: Expressing Yourself', type: 'activity', icon: '💬' },
                { id: 'french_m11_review', title: 'Chapter 11 Review', type: 'chapterReview', icon: '🏆' }
            ]
        },
        {
            unit: 12,
            theme: "Putting It All Together",
            culturalNote: "FRANCOPHONE AFRICA TOUR • REGIONAL INSIGHT. From Dakar to Kinshasa! French connects millions across Africa, each adding their own flavor. Félicitations!",
            lessons: [
                { id: 'french_m12_lesson1_questions', title: 'Lesson: Asking Questions', type: 'lesson', icon: '❓' },
                { id: 'french_m12_activity_listen1', title: 'Activity: Listen & Find (Questions)', type: 'activity', icon: '🎧' },
                { id: 'french_m12_cultural_note', title: 'Cultural Insight: The Future is Young', type: 'culturalNote', icon: '🌍' },
                { id: 'french_m12_quiz1_questions', title: 'Quick Quiz: Question Words', type: 'quiz', icon: '🥇' },
                { id: 'french_m12_lesson2_connectors', title: 'Lesson: Connecting Words', type: 'lesson', icon: '🔗' },
                { id: 'french_m12_activity_scramble1', title: 'Activity: Sentence Scramble (Full Sentences)', type: 'activity', icon: '📝' },
                { id: 'french_m12_quiz2_connectors', title: 'Quick Quiz: Connectors', type: 'quiz', icon: '🥇' },
                { id: 'french_m12_lesson3_phrases', title: 'Lesson: Everyday Phrases', type: 'lesson', icon: '💬' },
                { id: 'french_m12_activity_sort1', title: 'Activity: Category Sort (Cumulative Review)', type: 'activity', icon: '🗂️' },
                { id: 'french_m12_quiz3_phrases', title: 'Quick Quiz: Useful Phrases', type: 'quiz', icon: '🥇' },
                { id: 'french_m12_activity_convo1', title: 'Simple Conversation: Real-World Practice', type: 'activity', icon: '💬' },
                { id: 'french_m12_review', title: 'Chapter 12 Review', type: 'chapterReview', icon: '🏆' }
            ]
        }
    ],
    storybooks: {
        // Placeholder story - reusing Ananse structure (will need French-specific story later)
        "ananse_and_the_pot_of_wisdom_french": {
            id: "ananse_and_the_pot_of_wisdom_french",
            title: "Ananse et le Pot de Sagesse",
            pages: [
                // Page 1
                {
                    illustrationUrl: "https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/tjYAi3z.jpg",
                    narration: {
                        french: null, // NOTE: French audio to be recorded (see CR-008: French Content Incomplete)
                        english: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/english_story_ananse_p1.mp3"
                    },
                    text: [{
                        "french": "Il y a très longtemps, Ananse l'araignée cherchait à devenir le plus sage de tous. Il a rassemblé la sagesse de partout—l'agriculture, la construction, la musique—et l'a scellée dans un pot d'argile. Ananse murmura avec malice : « C'est MA sagesse maintenant. » « Personne d'autre ne peut l'avoir ! »",
                        "english": "Long ago, Ananse the spider sought to be the wisest. He gathered wisdom from everywhere—farming, building, music—and sealed it in a clay pot. \"This is MY wisdom now,\" Ananse whispered. \"No one else can have it!\""
                    }],
                    interactiveElements: [{
                        id: 'hotspot_1_1',
                        coords: { top: '10%', left: '75%', width: '15%', height: '15%' },
                        audioUrl: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/sfx_shimmer.mp3"
                    }]
                },
                // Page 2
                {
                    illustrationUrl: "https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/xnCcnAm.jpg",
                    narration: {
                        french: null,
                        english: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/english_story_ananse_p2.mp3"
                    },
                    text: [{
                        "french": "Ananse ne voulait pas que quelqu'un trouve son pot. Alors il a décidé de le cacher tout en haut d'un grand arbre. Il a attaché le pot à son ventre et a commencé à grimper. Mais le pot n'arrêtait pas de se balancer et de cogner ses genoux. « Aïe ! C'est plus difficile que je ne pensais », grogna-t-il.",
                        "english": "Ananse didn't want anyone to find his pot. So he decided to hide it at the very top of a tall tree. He tied the pot to his belly and began to climb. But the pot kept swinging and bumping his knees. \"Ouch! This is harder than I thought,\" he grumbled."
                    }],
                    interactiveElements: [{
                        id: 'hotspot_2_1',
                        coords: { top: '35%', left: '55%', width: '30%', height: '40%' },
                        audioUrl: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/sfx_parrot_sad_whistle.mp3"
                    }]
                },
                // Page 3
                {
                    illustrationUrl: "https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/UeiRenf.jpg",
                    narration: {
                        french: null,
                        english: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/english_story_ananse_p3.mp3"
                    },
                    text: [{
                        "french": "En bas, le fils d'Ananse le regardait se débattre. « Papa », appela-t-il, « pourquoi ne pas attacher le pot dans ton dos plutôt ? » Ananse s'arrêta net. « Hmm... c'est une idée intelligente », dit-il lentement. « Mais attends... si mon fils sait ça, peut-être que je n'ai pas TOUTE la sagesse après tout ! »",
                        "english": "Down below, Ananse's son watched him struggle. \"Papa,\" he called, \"why not tie the pot to your back instead?\" Ananse froze. \"Hmm… that's a smart idea,\" he said slowly. \"But wait… if my son knows that, maybe I don't have ALL the wisdom after all!\""
                    }],
                    interactiveElements: [{
                        id: 'hotspot_3_1',
                        coords: { top: '75%', left: '20%', width: '60%', height: '20%' },
                        audioUrl: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/sfx_river.mp3"
                    }]
                },
                // Page 4
                {
                    illustrationUrl: "https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/Zuk9rZf.jpg",
                    narration: {
                        french: null,
                        english: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/english_story_ananse_p4.mp3"
                    },
                    text: [{
                        "french": "Ananse se mit en colère. « Si même un enfant sait quelque chose que je ne sais pas, alors à quoi bon ? » Il arracha le pot de son ventre et le jeta par terre. CRASH ! Le pot se brisa en mille morceaux. La sagesse s'envola partout—dans le vent, les arbres, les rivières, et les gens.",
                        "english": "Ananse got angry. \"If even a child knows something I don't, then what's the point?\" He yanked the pot off his belly and threw it to the ground. CRASH! The pot broke into a thousand pieces. Wisdom flew everywhere—into the wind, the trees, the rivers, and the people."
                    }],
                    interactiveElements: [{
                        id: 'hotspot_4_1',
                        coords: { top: '60%', left: '30%', width: '15%', height: '20%' },
                        audioUrl: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/sfx_twinkle.mp3"
                    }]
                },
                // Page 5
                {
                    illustrationUrl: "https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/3JCPE5z.jpg",
                    narration: {
                        french: null,
                        english: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/english_story_ananse_p5.mp3"
                    },
                    text: [{
                        "french": "Depuis ce jour, tout le monde a eu un peu de sagesse. Certains savaient comment guérir avec des plantes. Certains savaient raconter des histoires qui faisaient rire les gens. Certains savaient construire des maisons solides ou diriger avec gentillesse. Même Ananse a dû admettre : « Peut-être que la sagesse est meilleure quand elle est partagée. »",
                        "english": "From that day on, everyone had a little bit of wisdom. Some knew how to heal with herbs. Some knew how to tell stories that made people laugh. Some knew how to build strong homes or lead with kindness. Even Ananse had to admit: \"Maybe wisdom is better when it's shared.\""
                    }],
                    interactiveElements: [{
                        id: 'hotspot_5_1',
                        coords: { top: '10%', left: '70%', width: '25%', height: '25%' },
                        audioUrl: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/sfx_shimmer.mp3"
                    }]
                },
                // Page 6
                {
                    illustrationUrl: "https://storage.googleapis.com/speak-roots-v2.firebasestorage.app/public/marketing/uc0oww1.jpg",
                    narration: {
                        french: null,
                        english: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/english_story_ananse_p6.mp3"
                    },
                    text: [{
                        "french": "Et toi, quelle sagesse vas-tu partager aujourd'hui ?",
                        "english": "And you, what wisdom will you share today?"
                    }],
                    interactiveElements: [{
                        id: 'hotspot_6_1',
                        coords: { top: '15%', left: '60%', width: '30%', height: '35%' },
                        audioUrl: "https://storage.googleapis.com/speak-roots.appspot.com/storybook_audio/sfx_twinkle.mp3"
                    }]
                }
            ]
        }
    }
};

